<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/dan1.png" class="steps step1" v-if="status==1">
			<img src="../../assets/images/dan2.png" class="steps step2" v-if="status==2">
			<img src="../../assets/images/dan3.png" class="steps step3" v-if="status==3">
			<img src="../../assets/images/dan4.png" class="steps step4" v-if="status==4">
			<img src="../../assets/images/dan5.png" class="steps step5" v-if="status==5">
			<img src="../../assets/images/dan6.png" class="steps step6" v-if="status==6">
			<div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"下一步":status==3?"下一步":status==4?"下一步":status==5?"下一步":status==6?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
<!--        <breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'订单管理'},{title:'采购订单列表 '}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
			<div class="h-piece">
				<div class="h-formBox">
					<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="　　采购订单编号" style="width: 50%;">
								<el-input v-model="formInline.cgId" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
							</el-form-item>
							<el-form-item label="　　销售订单编号" style="width: 50%;">
								<el-input v-model="formInline.orderCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="产品型号/编码">
										<el-input clearable v-model="formInline.productNoOrDes" placeholder="请输入"></el-input>
									</el-form-item>
									<el-form-item label="　采购单类型">
										<el-select clearable v-model="formInline.cgddlx" placeholder="请选择">
											<el-option v-for="item in caigdlxList" :key="item.value" :label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="　供应商名称">
										<el-input v-model="formInline.suserName" placeholder="请输入"></el-input>
									</el-form-item>
									<el-form-item label="订单状态">
										<brselect style="width: 100%;"
												  category="cg_status" v-model="formInline.statusList"
												  :multiple="true"
												  :v="formInline.statusList" :clearable="true"></brselect>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="物流单号">
										<el-input v-model="formInline.waybillId" placeholder="请输入"></el-input>
									</el-form-item>
									<el-form-item label="国家">
										<brselect style="width: 100%;" category="YLCountry_agent" v-model="formInline.ycountry" :v="formInline.ycountry" :clearable="true"></brselect>
									</el-form-item>
									<el-form-item label="预测人">
										<el-input v-model="formInline.ycuname" placeholder="请输入"></el-input>
									</el-form-item>
									<el-form-item label="预测单号">
										<el-input v-model="formInline.ycId" placeholder="请输入"></el-input>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="创建时间" style="width: 50%;">
										<el-date-picker
												placeholder="请选择"
												v-model="formInline.cdatebegin"
												clearable
												type="date"
												value-format="yyyy-MM-dd" >
										</el-date-picker>
										<span class="w-time-to">至</span>
										<el-date-picker
												placeholder="请选择"
												v-model="formInline.cdateend"
												clearable
												type="date"
												value-format="yyyy-MM-dd" >
										</el-date-picker>
									</el-form-item>
									<el-form-item label="发票状态">
										<brselect category="cg_fapiao" v-model="formInline.pzfileFlag" :v="formInline.pzfileFlag" :clearable="true"></brselect>
									</el-form-item>
									<!-- <el-form-item label="付款状态">
										<brselect category="cg_fkstatus" v-model="formInline.isPayment" :v="formInline.isPayment" :clearable="true"></brselect>
									</el-form-item> -->
									<el-form-item label="付款状态">
										<brselect category="cg_fkstatus" v-model="formInline.payType" :v="formInline.payType" :clearable="true"></brselect>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="审核通过时间" style="width: 50%;">
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.shenhetimebegin"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.shenhetimeend"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                    </el-form-item>
<!--                                    <el-form-item label="SAP订单号" v-if="nwxflag=='wx' || nwxflag=='all'">
                                        <el-input clearable v-model="formInline.sapCode" placeholder="请输入"></el-input>
                                    </el-form-item>-->
									<el-form-item label="　　SAP订单号" v-if="nwxflag=='wx' || nwxflag=='all'" style="width: 50%;">
										<el-input v-model="formInline.sapCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
									</el-form-item>
									<el-form-item label="　验收状态">
										<el-select clearable v-model="formInline.isAccept" placeholder="请选择">
											<el-option v-for="item in isAcceptList" :key="item.value" :label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="采购公司" v-if="!(nwxflag=='wx' || nwxflag=='all')">
										<brselect category="supplier_cpy_code" v-model="formInline.purchaseOrgCode" :v="formInline.purchaseOrgCode" :clearable="true"></brselect>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="收货时间" style="width: 50%;">
										<el-date-picker
												placeholder="请选择"
												v-model="formInline.shdatebegin"
												clearable
												type="date"
												value-format="yyyy-MM-dd" >
										</el-date-picker>
										<span class="w-time-to">至</span>
										<el-date-picker
												placeholder="请选择"
												v-model="formInline.shdateend"
												clearable
												type="date"
												value-format="yyyy-MM-dd" >
										</el-date-picker>
									</el-form-item>
									<el-form-item label="采购公司" v-if="nwxflag=='wx' || nwxflag=='all'">
										<brselect category="supplier_cpy_code" v-model="formInline.purchaseOrgCode" :v="formInline.purchaseOrgCode" :clearable="true"></brselect>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>

					    <!-- <div class="h-formBtnOut h-columnCenter">
					        <el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
					        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
					        <el-button class="h-btn h-formBtn h-bggreen h-mr20" icon="el-icon-plus" style="width:2rem;" v-auth="'addCgOrder'" @click="newCgOrder">
					            新增采购订单
					        </el-button>
					    </div> -->
					</el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
							<el-button class="h-btn h-formBtn h-bggreen h-mr20" icon="el-icon-plus" style="width:2rem;" v-auth="'addCgOrder'" @click="newCgOrder">
							    新增采购订单
							</el-button>
						</div>
					</div>
				</div>
			</div>
            <div class="h-row purchaselist">
				<div class="h-rowIn" style="width:100%;">
                    <el-table
                        ref="multipleTable"
                    	@selection-change="handleSelectionChange"
                        :data="tableData"
                    	:span-method="objectSpanMethod"
                        stripe
                    	:row-style="cellstyle"
                        style="width: 100%"
                    	:border="true"
                    	max-height="450"
                        >
                        <el-table-column
                        type="selection"
                        width="40"
                    	fixed
                        >
                        </el-table-column>
                        <el-table-column
                            type="index"
                            width="40"
                            label="#"
                            >
                        </el-table-column>
                    	<el-table-column
                            prop="productCateName"
                            label="产品大类"
                            :show-overflow-tooltip="true"
                            width="100"
                            >
                        </el-table-column>

                    	<el-table-column
                            prop="productNo"
                            label="产品编码"
                            :show-overflow-tooltip="true"
                            width="110"
                            >
                        </el-table-column>

                        <el-table-column
                            prop="productDes"
                            label="产品型号"
                            :show-overflow-tooltip="true"
                             width="150"
                             >
                    		<template scope="scope">
                    			<div style="text-align: left;">
                    				{{scope.row.productDes}}
                    			</div>
                    		</template>
                        </el-table-column>
                      <el-table-column
                          prop="oemDesc"
                          label="规格型号"
                          width="120"
                          :show-overflow-tooltip="true"
                      >
                      </el-table-column>
                        <el-table-column
                            prop="count"
                            label="数量"
                            width="60"
                    		:show-overflow-tooltip="true"
                            >
                    			<template scope="scope">
                    				<div style="text-align: right;">
                    					{{scope.row.count}}
                    				</div>
                    			</template>
                        </el-table-column>
                    	<el-table-column
                    			prop="unitPrice"
                    			label="采购单价"
                    			:show-overflow-tooltip="true"
								v-if="!zlFlag"
                    			width="90"
                    	>
                    		<template scope="scope">
                    			<div style="text-align: right;">
                    				{{scope.row.unitPrice}}
                    			</div>
                    		</template>
                    	</el-table-column>
                        <el-table-column
                            prop="totalPrice"
                            label="采购总价"
							v-if="!zlFlag"
                    		:show-overflow-tooltip="true"
                            width="90"
                            >
                    			<template scope="scope">
                    				<div style="text-align: right;">
                    					{{scope.row.totalPrice}}
                    				</div>
                    			</template>
                        </el-table-column>
                    	<el-table-column
                    			prop="salePrice"
                    			label="销售单价"
                    			:show-overflow-tooltip="true"
                    			width="90"
								:key="Math.random()"
                    			v-if="_user.usertype == '0' && !zlFlag"
                    	>
                    		<template scope="scope">
                    			<div style="text-align: right;">
                    				{{scope.row.salePrice}}
                    			</div>
                    		</template>
                    	</el-table-column>
                    	<el-table-column
                    			prop="saleTotalPrice"
                    			label="销售总价"
                    			:show-overflow-tooltip="true"
                    			width="90"
								:key="Math.random()"
                    			v-if="_user.usertype == '0' && !zlFlag"
                    	>
                    		<template scope="scope">
                    			<div style="text-align: right;">
                    				{{scope.row.saleTotalPrice}}
                    			</div>
                    		</template>
                    	</el-table-column>
                      <el-table-column
                          prop="receivedCount"
                          label="已收货数量"
                          :show-overflow-tooltip="true"
                          min-width="120"
                      >
                        <template scope="scope">
                          <div style="text-align: right;">
                            {{scope.row.receivedCount}}
                          </div>
                        </template>
                      </el-table-column>
						<el-table-column
								prop="payType"
								label="付款状态"
								:show-overflow-tooltip="true"
								width="90"
								:key="Math.random()"
								v-if="_user.usertype == '0' && !zlFlag"
						>
							<template slot-scope="scope">
								<dictname category="cg_fkstatus"  :v="scope.row.payType"/>
							</template>
						</el-table-column>
						<el-table-column
								prop="paymentProportion"
								label="付款比例"
								:show-overflow-tooltip="true"
								v-if="!zlFlag"
								width="120"
						>
						</el-table-column>
                        <el-table-column
                        prop="code"
                        label="采购订单编号"
                    	:show-overflow-tooltip="true"
                        width="120">
                        </el-table-column>
                        <el-table-column
                            prop="orderCode"
                            label="销售订单编号"
                            :show-overflow-tooltip="true"
                            width="130"
                            >
                    	</el-table-column>
                    	<el-table-column
                    			prop="sapCode"
                    			label="SAP订单号"
                    			width="110"
                    			:show-overflow-tooltip="true"
                    	>
						</el-table-column>
						<el-table-column v-if=' _user.usertype == "0"&&roleTypeVisible'
                    			prop="sapType"
                    			label="SAP创建采购订单状态"
                    			width="110"
                    			:show-overflow-tooltip="true"
                    	>
							<template scope="scope">
                  <div v-if="scope.row.sapType == 'S'||scope.row.sapCode != null">
                      创建成功
                  </div>
                  <div v-else-if="scope.row.sapType == null || scope.row.sapType == ''">
                      待创建
                  </div>
                  <div v-else>
                      创建失败
                  </div>
               </template>
						</el-table-column>
						<el-table-column v-if=' _user.usertype == "0"&&roleTypeVisible'
                    			prop="sapMessage"
                    			label="SAP返回内容"
                    			width="110"
                    			:show-overflow-tooltip="true"
                    	>
                    	</el-table-column>
                    	<el-table-column
                    	    prop="status"
                    	    label="订单状态"
                    	    width="90"
                    	    >
                    		<template slot-scope="scope">
                    			<dictname category="cg_status"  :v="scope.row.status"/>
                    		</template>
                    	</el-table-column>
                        <el-table-column
                            prop="invoiceStatus"
                            label="SAP发票校验状态"
                            width="110"
                            :show-overflow-tooltip="true"
                        >
                            <template scope="scope">
                                <div v-if="scope.row.invoiceStatus === 2">
                                    全部校验
                                </div>
                                <div v-else-if="scope.row.invoiceStatus === 1">
                                    部分校验
                                </div>
                                <div v-else>
                                    待校验
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="suserName"
                            label="供应商名称"
                            :show-overflow-tooltip="true"
                            width="180"
                            >
                    		<template scope="scope">
                    		    <div style="text-align: left;">
                    				{{scope.row.suserName}}
                    			</div>
                    		</template>
                        </el-table-column>
						<el-table-column
								prop="purchaseOrgCode"
								label="采购公司"
								:show-overflow-tooltip="true"
								width="220"
						>
							<template slot-scope="scope">
								<dictname category="supplier_cpy_code"  :v="scope.row.purchaseOrgCode"/>
							</template>
						</el-table-column>
                    	<el-table-column
                    			prop="agentName"
                    			label="经销商名称"
                    			width="180"
								v-if='_user.usertype == "0"'
                    			:show-overflow-tooltip="true"
                    	>
                    		<template scope="scope">
                    		    <div style="text-align: left;">
                    				{{scope.row.agentName}}
                    			</div>
                    		</template>
                    	</el-table-column>
                        <el-table-column
                            prop="typeName"
                    		:show-overflow-tooltip="true"
                            label="订单类型"
                            width="110"
                            >
                        </el-table-column>
                    	<el-table-column
                    			prop="waybillType"
                    			label="物流类型"
                    			:show-overflow-tooltip="true"
                    			width="90">
                    		<template slot-scope="scope">
								<span v-if="scope.row.waybillType == '3' ">
									库发
								</span>
								<span v-else>
									<dictname category="waybill_type"  :v="scope.row.waybillType"/>
								</span>
                    		</template>
                    	</el-table-column>
                        <el-table-column
                                prop="waybillName"
                                label="物流公司"
                                width="160"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
						<el-table-column
								prop="waybillId"
								label="物流单号"
								width="160"
								:show-overflow-tooltip="true"
						>
						</el-table-column>
                        <el-table-column
                                prop="waybillDate"
                                label="预计发货日期"
                                width="160"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                    	<el-table-column
                    	    prop="receiver"
                    	    label="接收人"
                    	    width="80"
                    		:show-overflow-tooltip="true"
                    	    >
                    	</el-table-column>
                    	<el-table-column
                    			prop="receverPhone"
                    			label="接收人手机号"
                    			width="130"
                    			:show-overflow-tooltip="true"
                    	>
                    		<template scope="scope">
                    			<div style="text-align: left;">
                    				{{scope.row.receverPhone}}
                    			</div>
                    		</template>
                    	</el-table-column>
                    	<el-table-column
                    			prop="receiveUnit"
                    			label="收货单位"
                    			width="160"
                    			:show-overflow-tooltip="true"
                    	>
                    		<template scope="scope">
                    		    <div style="text-align: left;">
                    				{{scope.row.receiveUnit}}
                    			</div>
                    		</template>
                    	</el-table-column>
                    	<el-table-column
                    			prop="detailAddress"
                    			label="收货地址"
                    			width="180"
                    			:show-overflow-tooltip="true"
                    	>
                    	</el-table-column>
                        <el-table-column
                            prop="expectDate"
                            :show-overflow-tooltip="true"
                            label="期望到货时间"
                    		value-format="yyyy-MM-dd"
                            width="120"
                            >
                        </el-table-column>
						<el-table-column
								prop="shenhetime"
								label="审核通过时间"
								:show-overflow-tooltip="true"
								width="140"
						>
						</el-table-column>
                        <el-table-column
                            prop="cuname"
                            label="创建人"
                            :show-overflow-tooltip="true"
                            width="90"
                        >
                        </el-table-column>

                    	<el-table-column
                            prop="cdate"
                            label="创建时间"
                            :show-overflow-tooltip="true"
                            width="170"
                            >
                    	</el-table-column>
                    	<el-table-column
                            prop="ldate"
                            label="更新时间"
                            :show-overflow-tooltip="true"
                            width="170"
                            >
                    	</el-table-column>
						<el-table-column
								prop="shdate"
								label="收货时间"
								:formatter="formatDate"
								:show-overflow-tooltip="true"
								width="170"
						>
						</el-table-column>
                    	<el-table-column
                    			prop="ycountry"
                    			label="国家"
                    			:show-overflow-tooltip="true"
                    			width="80"
                    	>
                    		<template slot-scope="scope">
                    			{{scope.row.ycountry | dictname('YLCountry_agent')}}
                    		</template>
                    	</el-table-column>
                    	<el-table-column
                    			prop="ycuname"
                    			label="预测人"
                    			:show-overflow-tooltip="true"
                    			width="80"
                    	>
                    	</el-table-column>
                    	<el-table-column
                    			prop="yremark"
                    			label="备注"
                    			:show-overflow-tooltip="true"
                    			width="150"
                    	>
                    		<template scope="scope">
                    			<div style="text-align: left;">
                    				{{scope.row.yremark}}
                    			</div>
                    		</template>
                    	</el-table-column>
                    	<el-table-column
                    			prop="ycId"
                    			label="预测单号"
                    			:show-overflow-tooltip="true"
                    			width="170"
                    	>
                    	</el-table-column>
						<el-table-column
								prop="specificDivision"
								label="改制目录"
								:show-overflow-tooltip="true"
								width="170"
						>
						</el-table-column>
						<el-table-column
								prop="specificReform"
								label="改制要求"
								:show-overflow-tooltip="true"
								width="170"
						>
						</el-table-column>
						<el-table-column
								prop="specificRemark"
								label="改制备注"
								:show-overflow-tooltip="true"
								width="170"
						>
						</el-table-column>
						<el-table-column
								prop="isAccept"
								label="验收状态"
								width="100"
								:show-overflow-tooltip="true"
						>
							<template slot-scope="scope">
								<span v-if="scope.row.isAccept == 0">待验收</span>
								<span v-if="scope.row.isAccept==1">已验收</span>
							</template>
						</el-table-column>
<!--						<el-table-column
								prop="acceptTime"
								label="验收时间"
								:show-overflow-tooltip="true"
								width="100">
						</el-table-column>
						<el-table-column
								prop="signStatus"
								label="签收状态"
								:show-overflow-tooltip="true"
								width="60">
							<template scope="scope">
								<span v-if="scope.row.signStatus == 1">已验收</span>
								<span v-if="scope.row.signStatus == 0">未验收</span>
							</template>
						</el-table-column>-->

                        <!--<el-table-column-->
                                <!--prop="invoiceno"-->
                                <!--label="发票号"-->
                                <!--width="170"-->
                                <!--:show-overflow-tooltip="true"-->
                        <!--&gt;-->
                        <!--</el-table-column>-->
                        <!--<el-table-column-->
                                <!--prop="invoicedate"-->
                                <!--label="发票日期"-->
                                <!--width="110"-->
                                <!--value-format="yyyy-MM-dd"-->
                                <!--:show-overflow-tooltip="true"-->
                        <!--&gt;-->
                        <!--</el-table-column>-->
                        <!--<el-table-column-->
                                <!--label="附件"-->
                                <!--width="180"-->
                        <!--&gt;-->
                            <!--<template slot-scope="scope">-->
                                <!--<brupload-->
                                        <!--:refid=scope.row.invoiceno-->
                                        <!--reftype="发票维护附件"-->
                                        <!--:showtime="false"-->
                                <!--&gt;-->
                                    <!--<el-button size="small" type="text">上传</el-button>-->
                                <!--</brupload>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                        <el-table-column
                        label="操作"
						fixed="right"
						width="420"
                        >
                        <template slot-scope="scope">
							<div style="text-align: left;">
								<el-button
									v-if="scope.row.status == 0 && scope.row.source == 1 && !zlFlag"
									type="text"
									size="small"
									@click="editPage(scope.row)"
									class="h-tableLink h-btn">
									编辑
								</el-button>

                                <!--
								<el-button
									v-if="scope.row.status == 1 && _user.usercode == scope.row.cgjlcode && scope.row.type == 1"
									type="text"
									size="small"
									@click="getDetailEditNx(scope.row.orderId, scope.row.instid)"
									class="h-tableLink h-btn">
										编辑
								</el-button>
                                <el-button
                                    v-if="scope.row.status == 1 && _user.usercode == scope.row.cgjlcode && scope.row.type == 2"
                                    type="text"
                                    size="small"
                                    @click="getDetailEditWx(scope.row.orderId, scope.row.instid)"
                                    class="h-tableLink h-btn">
                                        编辑
                                </el-button>
                                <el-button
                                    v-if="scope.row.status == 1 && _user.usercode == scope.row.cgjlcode && scope.row.type == 3"
                                    type="text"
                                    size="small"
                                    @click="getDetailEditSh(scope.row.orderId, scope.row.instid)"
                                    class="h-tableLink h-btn">
                                        编辑
                                </el-button>
                                -->

								<!--<el-button-->
								<!--type="text"-->
								<!--size="small"-->
								<!--class="h-tableLink h-btn">-->
										<!--删除-->
								<!--</el-button>-->
		<!--							<el-button-->
		<!--							type="text"-->
		<!--							size="small"-->
		<!--							@click="selectProSupplier(scope.row)"-->
		<!--							class="h-tableLink h-btn">-->
		<!--							        供应商商品占比-->
		<!--							</el-button>-->
								<el-button
										type="text"
										size="small"
										v-if="!zlFlag"
										@click="getDetail(scope.row,scope.row.cgId,scope.row.instid,scope.row.zhubiaoid,scope.row.type,scope.row.cgIdStr)"
										class="h-tableLink h-btn">
									查看
								</el-button>
								<el-button v-if="scope.row.orderCategory1 != '28' && fpxqFlag"
										type="text"
										size="small"
										@click="fapiaoXiangqing(scope.row.code)"
										class="h-tableLink h-btn">
									发票详情
								</el-button>
								<el-button
										type="text"
										v-if="scope.row.shenpiflag"
										size="small"
										@click="approve(scope.row)"
										class="h-tableLink h-btn">
									审批
								</el-button>

								<el-button v-if='scope.row.status == 3 && (scope.row.waybillType == "2"||scope.row.waybillType == "3")&& scope.row.orderCategory1 != "28" && !zlFlag'
								type="text"
								size="small"
								@click="fahuo(scope.row)"
								class="h-tableLink h-btn">
									  发货
								</el-button>

								<el-button v-if='(scope.row.status == 3 || scope.row.status == 4|| scope.row.status == 5) && (scope.row.waybillType == "2"||scope.row.waybillType == "3")&& scope.row.orderCategory1 != "28" && !zlFlag'
								type="text"
								size="small"
								@click="updateWaybillId(scope.row)"
								class="h-tableLink h-btn">
									  物流维护
								</el-button>

								<el-button v-if='scope.row.status == "4" &&  _user.usertype == "0" &&
										((scope.row.waybillType == "2"&& scope.row.fahuoflag)||scope.row.waybillType == "3")&&scope.row.deliveryMethod != 2 && scope.row.orderCategory1 != "28" && scope.row.orderCategory1 != "42" && !zlFlag'
										   type="text"
										   size="small"
										   @click="shouhuoSh(scope.row,scope.row.instid,scope.row.cgId, scope.row.count, scope.row.receivedCount, (scope.row.count-scope.row.receivedCount),scope.row.code,scope.row.type,scope.row.zhubiaoid,scope.row.code)"
										   class="h-tableLink h-btn">
									 收货
								</el-button>
								<el-button v-if='scope.row.cstatusStr.includes("4") &&  _user.usertype == "0" && scope.row.orderCategory1 == "28"&&saveHkVisible && !zlFlag'
										   type="text"
										   size="small"
										   @click="shouhuoHk(scope.row)"
										   class="h-tableLink h-btn">
									 收货
								</el-button>
                <el-button v-if='scope.row.cstatusStr.includes("4") &&  _user.usertype == "0" && scope.row.orderCategory1 == "42"&&saveHkVisible && !zlFlag'
                           type="text"
                           size="small"
                           @click="shouhuoSalse(scope.row)"
                           class="h-tableLink h-btn">
                  收货
                </el-button>
								<el-button v-if='scope.row.cstatusStr.includes("4") &&  _user.usertype == "0" && (scope.row.orderCategory1 == "28" || scope.row.orderCategory1 == "42") && !zlFlag'
										   type="text"
										   size="small"
										   @click="uploadPri(scope.row)"
										   class="h-tableLink h-btn">
									 上传入库凭证
								</el-button>
								<!-- <el-button v-if='scope.row.type=="3" &&scope.row.status == "4" &&  _user.usertype == "0" &&
								((scope.row.waybillType == "2"&& scope.row.fahuoflag)||scope.row.waybillType == "3")'
										   type="text"
										   size="small"
										   @click="shouhuoSh(scope.row,scope.row.instid,scope.row.cgId, scope.row.count, scope.row.receivedCount, (scope.row.count-scope.row.receivedCount),scope.row.code,scope.row.type,scope.row.zhubiaoid,scope.row.code)"
										   class="h-tableLink h-btn">
									 收货
								</el-button> -->

								<el-button v-if="scope.row.instid != null && scope.row.instid != '' && scope.row.orderCategory1 != '28' && !zlFlag"
										size="small" class="h-tableLink h-btn"
										@click="genzongLiuch(scope.row.instid)">
									跟踪
								</el-button>

                                <!--
								<el-button
										type="text"
										v-if="scope.row.status >= 3 && scope.row.status <= 5 && scope.row.source == 0 && _user.usercode == scope.row.cgjlcode"
										v-auth="'chehui'"
										size="small"
										@click="chehui(scope.row)"
										class="h-tableLink h-btn">
									撤回
								</el-button>

								<el-button
										v-if="scope.row.status <= 6 && scope.row.source == 1"
										v-auth="'deleteCgOrder'"
										size="small" class="h-tableLink h-btn"
										@click="deleteCgOrder(scope.row)">
									撤销
								</el-button>
								-->

								<el-button
										type="text"
										v-if="
										scope.row.status !='0' &&  scope.row.status !='7'&& scope.row.orderCategory1 != '28' && (
										((scope.row.status ==3 || scope.row.status == 4)
											&& (_user.usercode == scope.row.cgjlcode))
											|| _user.usercode == scope.row.cucode
												|| adminFlag)"
										v-auth="'chehui'"
										size="small"
										@click="chehui(scope.row)"
										class="h-tableLink h-btn">
									撤回
								</el-button>
								<el-button
										type="text"
										v-if="(scope.row.source == 0 &&scope.row.type == 3 &&
										scope.row.isPay == 0 )&& (
										payFlag|| adminFlag)"
										v-auth="'chehui'"
										size="small"
										@click="payMoney(scope.row)"
										class="h-tableLink h-btn">
									付款
								</el-button>
<!--								<el-button
										v-if="scope.row.signStatus == '1'"
										size="small" class="h-tableLink h-btn"
										@click="seeFile(scope.row)">查看附件
								</el-button>-->

								<el-button
										v-if="scope.row.status >= 3"
										size="small" class="h-tableLink h-btn"
										@click="seeQualityFile(scope.row)">查看附件
								</el-button>

								<span v-if="!(scope.row.source==0&&scope.row.type ==3) && !zlFlag" style="margin-left:5px" >
									<el-button
										v-if="scope.row.status >=  3 && scope.row.status != 6 &&  scope.row.status != 7 && scope.row.orderId  && scope.row.orderCategory1 != '28' "
										type="text"
										size="small"
										class="h-tableLink h-btn" @click="toPrintCode(scope.row)">
										打印条形码
									</el-button>
								</span>

								<!--<el-button-->
										<!--v-if="scope.row.status < 4 && scope.row.orderCode == null && scope.row.ycId == null"-->
										<!--v-auth="'deleteCgOrder'"-->
										<!--size="small" class="h-tableLink h-btn"-->
										<!--@click="deleteCgOrder(scope.row)">-->
									<!--撤销-->
								<!--</el-button>-->

							</div>

							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-xg" v-if="scope.row.status == 0 && scope.row.source == 1" title="编辑" @click="editPage(scope.row.cgId)"></span>
								<span class="l-operationlist br-operation-look" title="查看" @click="getDetail(scope.row.cgId)"></span>
								<span class="l-operationlist br-operation-sp" v-if="scope.row.shenpiflag" title="审批" @click="approve(scope.row)"></span>
								<span class="l-operationlist br-operation-fh" v-if='scope.row.status == 3 && (scope.row.waybillType == "2"||scope.row.waybillType == "3")' title="发货" @click="fahuo(scope.row.cgId,scope.row.code)"></span>
								<span class="l-operationlist br-operation-wlwh"v-if='(scope.row.status == 4||scope.row.status == 5) && (scope.row.waybillType == "2"||scope.row.waybillType == "3")'  title="物流维护" @click="updateWaybillId(scope.row)"></span>
								<span class="l-operationlist br-operation-sh" v-if='scope.row.status == 4 && (scope.row.waybillType == "2"||scope.row.waybillType == "3") && scope.row.fahuoflag' title="收货" @click="shouhuoSh(scope.row.cgId, scope.row.count, scope.row.receivedCount, (scope.row.count-scope.row.receivedCount),scope.row.code)"></span>
								<span class="l-operationlist br-operation-spgz" v-if="scope.row.instid != null && scope.row.instid != ''" title="跟踪审批" @click="genzongLiuch(scope.row.instid)"></span>
								<span class="l-operationlist br-operation-zf" v-if="scope.row.status < 4||scope.row.status == 6" title="作废" @click="deleteCgOrder(scope.row)"></span>
							</div> -->
						</template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
							<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="!zlFlag" @click="fahuoBatch">批量发货</el-button>
							<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="!zlFlag" @click="allWaybillCommit">批量维护物流信息</el-button>
<!--							<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon" @click="invoice"  v-auth="'cglb_fpwh'">发票信息维护</el-button>-->
                            <!-- <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入</el-button> -->
                            <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
											 clsname="orderCgImportExcel" :startrow="3" @callback="uploadExcelFilecallback"/>
							<el-button class="h-btn h-formBtn h-bgblueQ" v-auth="'gongysfukuan'" @click="newFukuan">供应商付款</el-button>
							<el-button class="h-btn h-formBtn h-bgblueQ" v-auth="'shanghai_dayincaigd'" @click="shanghai_dayincaigd">打印采购单</el-button>
              <el-button class="h-btn h-formBtn h-bgblueQ"  @click="printDispatchList">打印发货单</el-button>
<!--							<el-button class="h-btn h-formBtn h-bgblueQ" @click="uploadShFile">批量上传签收资料</el-button>-->
							<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="!zlFlag" @click="uploadKpFile">开票资料</el-button>
							<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="!zlFlag" @click="uploadFkFile">付款操作手册</el-button>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible4" width="38%" class="h-dialog2 wuliu">
			<div class="h-dialogImg">
        		        <div class="h-disTable">
        		            <div class="h-tableCell">
        		                <h1>发票详情</h1>
        		            </div>
        		        </div>
        		    </div>
			<div class="h-rowIn" >
				<div class="h-rowBox">
					<div class="h-rowCon" style="padding-bottom: 0.8rem;">

						<el-table
								ref="multipleTable"
								:data="tableData4"
								stripe
								style="width: 100%"
								:border="true"
								max-height="220"
						>
							<el-table-column
									prop="invoiceNo"
									:show-overflow-tooltip="true"
									label="发票号">
							</el-table-column>
							<el-table-column
									prop="invoiceDate"
									:show-overflow-tooltip="true"
									label="发票日期">
							</el-table-column>
							<el-table-column
									prop="fpje"
									:show-overflow-tooltip="true"
									label="发票金额">
							</el-table-column>
							<el-table-column
									label="附件"
									width="180"
							>
								<template slot-scope="scope">
									<brupload
											:refid=scope.row.invoiceNo
											reftype="发票维护附件"
											:showtime="false"
									>
									</brupload>
								</template>
							</el-table-column>
						</el-table>

					</div>
				</div>
			</div>
		</el-dialog>

		<!--商品-供应商占比-->
		<el-dialog
				:close-on-click-modal="false"
				:visible.sync="showFujian"
				v-if="showFujian"
				class="h-dialog2"
		>
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>采购订单供应商产品占比</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding:20px;overflow: scroll">
				<h3>商品编码</h3><h6>{{proSupplier.productNo}}</h6>
				<h3>商品名</h3><h6>{{proSupplier.productDes}}</h6>
				<h3>产品总量</h3><h6>{{proSupplier.total}}</h6>
				<h3>供应商数量</h3><h6>{{proSupplier.num}}</h6>
				<h3>供应商占比</h3><h6>{{proSupplier.proportion}}</h6>
			</div>
		</el-dialog>


		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 wuliu">
		    <div class="h-dialogImg">
		        <div class="h-disTable">
		            <div class="h-tableCell">
		                <h1>维护发货物流信息</h1>
		            </div>
		        </div>
		    </div>
		    <div class="h-formLine">
		        <el-form ref="form" :model="fh" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
					<el-form-item  label="采购单号" class="h-elformWrap-2" style="width: 100%;">
						<el-input v-model="fh.code" readonly></el-input>
					</el-form-item>
					<el-form-item label="物流公司" class="h-elformWrap-2" style="width: 100%;">
						<el-input v-model="fh.waybillName" placeholder="请填写物流公司名称"></el-input>
					</el-form-item>
		            <el-form-item label="物流单号" class="h-elformWrap-2" style="width: 100%;">
		               <el-input v-model="fh.waybillId" placeholder="请填写物流单号"></el-input>
		            </el-form-item>
                    <el-form-item label="预计发货日期" class="h-elformWrap-2" style="width: 100%;" prop="date">
                        <el-date-picker style="width: 100%;"
                                        placeholder="请选择"
                                        v-model="fh.waybillDate"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                        </el-date-picker>
                    </el-form-item>
					<el-form-item label="机编码" class="h-elformWrap-2" style="width: 100%;">
					   <el-input v-model="fh.machineCode" placeholder="多个请以逗号分隔"></el-input>
					</el-form-item>
					<el-form-item label="上传附件" class="h-elformWrap-2" style="width: 100%;">
					   <brupload :refid="fh.code" :tpFlag="true" @tpclick="ylclick" reftype="采购订单发货附件" :showtime="false" uploadflag delflag></brupload>
					</el-form-item>
		        </el-form>
		    </div>
		    <div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-formBtn h-bgwhite" @click="cancel">取消</el-button>
				<el-button class="h-btn h-formBtn" type="primary" @click="saveTo">确定</el-button>
		    </div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisiblePay" class="h-dialog2 wuliu" @close="cancel1">
        		    <div class="h-dialogImg">
        		        <div class="h-disTable">
        		            <div class="h-tableCell">
        		                <h1>维护发票信息</h1>
        		            </div>
        		        </div>
        		    </div>
        		    <div class="h-formLine">
        		        <el-form ref="form" :rules="rules" :model="fh1" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
        					<el-form-item label="发票号" class="h-elformWrap-2" style="width: 100%;" prop="code">
								<el-input v-model="fh1.code" placeholder="请填写发票号"></el-input>
                            </el-form-item>
                            <el-form-item label="发票日期" class="h-elformWrap-2" style="width: 100%;" prop="date">
								<el-date-picker style="width: 100%;"
									placeholder="请选择"
									v-model="fh1.date"
										clearable
									type="date"
									value-format="yyyy-MM-dd" >
									</el-date-picker>
							</el-form-item>
							<el-form-item label="发票金额" class="h-elformWrap-2" style="width: 100%;" prop="fpje">
								<el-input v-model="fh1.fpje" placeholder="请填写发票金额"></el-input>
							</el-form-item>
        					<el-form-item label="上传附件" class="h-elformWrap-2" style="width: 100%;" prop="upload">
        					   <brupload v-model="fh1.upload" :refid="fh1.code" reftype="发票维护附件" :showtime="false" uploadflag delflag @filecallback="fileBack1"></brupload>
        					</el-form-item>
							<el-form-item label="付款订单" class="h-elformWrap-2 fkinput" style="width: 100%;" prop="fkdd">
								<div style="display: flex;">
									<el-input v-model="fh1.fkdd" placeholder="请填写付款订单,多个以英文;分割"></el-input>
									<div class="fkBtn" @click="addfk(fh1.fkdd)">添加</div>
								</div>
								<div class="fklistBox">
									<div class="fklists" v-for="(item,index) in fklist" :key="index">
										<div>{{item}}</div>
										<div class="fkcircle" @click="delfk(item,index)">x</div>
									</div>
								</div>
							</el-form-item>
							<el-form-item label="订单总额" class="h-elformWrap-2" style="width: 100%;" prop="ddze">
								<el-input v-model="fh1.ddze" ></el-input>
							</el-form-item>
        		        </el-form>
        		    </div>
        		    <div slot="footer" class="dialog-footer">
        				<el-button class="h-btn h-formBtn h-bgwhite" @click="cancel1">取消</el-button>
        				<el-button class="h-btn h-formBtn" type="primary" @click="saveTo1('form')">确定</el-button>
        		    </div>
        		</el-dialog>
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisibleSh0" class="h-dialog2 wuliu">
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>维护收货信息</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine">
				<el-form ref="form" :model="sh" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
					<el-form-item  label="采购单号" class="h-elformWrap-2" style="width: 100%;">
						<el-input v-model="sh.code" readonly></el-input>
					</el-form-item>
					<el-form-item label="总数量" class="h-elformWrap-2" style="width: 100%;">
						<el-input v-model="sh.count" readonly></el-input>
					</el-form-item>
					<el-form-item label="已收货数量" class="h-elformWrap-2" style="width: 100%;">
						<el-input v-model="sh.receivedCount" readonly></el-input>
					</el-form-item>
					<el-form-item label="待收货数量" class="h-elformWrap-2" style="width: 100%;">
						<el-input v-model="sh.notreceivedCount"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-formBtn h-bgwhite" @click="cancelSh">取消</el-button>
				<el-button class="h-btn h-formBtn" type="primary" @click="saveToSh">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisibleSh"  class="h-dialog2 wuliu">
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>维护收货信息</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine">
				<el-table
						ref="multipleTable"
						@selection-change="handleSelectionChange9390"
						:data="productlist1"
						stripe
						border
						style="width: 100%">
						<el-table-column
                                type="selection"
                                width="40"
                                label="全选">
                        </el-table-column>
						<el-table-column
								prop="code"
								label="采购单号"
								:show-overflow-tooltip="true"
								min-width="100">
						</el-table-column>
						<el-table-column
								prop="productNo"
								label="产品型号"
								min-width="100">
						</el-table-column>

						<el-table-column
								prop="count"
								label="总数量"
								min-width="70">
						</el-table-column>
						<el-table-column
								prop="receivedCount"
								label="已收数量"
								min-width="90">
							<!--<template slot-scope="scopes">
								<template  v-if="true">
									<el-input class="edit-input" size="small" v-model="scopes.row.receivedCount"></el-input>
								</template>
								<span v-else>{{ scopes.row.receivedCount }}</span>
							</template>-->
						</el-table-column>
						<el-table-column
								prop="notreceivedCount"
								label="待收数量"
								min-width="90">
							<!--<template slot-scope="scopes">
								<template  v-if="true">
									<el-input class="edit-input" size="small" v-model="scopes.row.notreceivedCount"></el-input>
								</template>
								<span v-else>{{ scopes.row.notreceivedCount }}</span>
							</template>-->
						</el-table-column>
						<el-table-column
								prop="newReceivedCount"
								label="本次收货数量"
								min-width="120">
							<template slot-scope="scopes">
								<template  v-if="true">
									<el-input class="edit-input" size="small" v-model="scopes.row.newReceivedCount"></el-input>
								</template>
								<span v-else>{{ scopes.row.newReceivedCount }}</span>
							</template>
						</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-formBtn h-bgwhite" @click="cancelSh">取消</el-button>
				<el-button class="h-btn h-formBtn" type="primary" @click="saveToSh">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="撤销订单" :visible.sync="zfyydialogFormVisible">
		    <el-form :model="zuofeiyy">
		        <el-form-item label="撤销原因" :label-width="100">
		            <brselect category="DD_ZFYY" :v="zuofeiyy.yy"
		                      v-model="zuofeiyy.yy" ></brselect>
		        </el-form-item>
		        <el-form-item label="备注" :label-width="100">
		            <el-input v-model="zuofeiyy.bz" auto-complete="off"></el-input>
		        </el-form-item>
		    </el-form>
		    <div slot="footer" class="dialog-footer">
		        <el-button @click="zfyydialogFormVisible = false">取 消</el-button>
		        <el-button type="primary" @click="submitzuofei">确 定</el-button>
		    </div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="供应商付款" width="67%" :visible.sync="orderCgPayment" class="h-dialog" @close="cancelcg">
			<div class="h-formLine" style="padding: 0.5rem 0.4rem 0 0.4rem;">
                <div class="h-disTable" style="margin-bottom: 0.2rem;">
                    <div class="h-tableCell">
                        <span style="font-size: 0.2rem;">{{gysName}}</span>
                    </div>

                </div>
				<div class="h-formBox">
					<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">

						<el-collapse-transition>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="付款状态">
										<brselect category="cg_fkstatus" v-model="formInline.isPayment" :v="formInline.isPayment" :clearable="true"></brselect>
									</el-form-item>
									<div class="l-screenBox">
										<div class="l-retrieval">
											<el-button class="h-btn h-formBtn" @click="jiansuo">检索</el-button>
											<el-button class="h-btn h-formBtn h-bgwhite" @click="chongzhil">重置</el-button>
										</div>
									</div>
								</div>

						</el-collapse-transition>

					</el-form>

				</div>
				<el-table
						ref="multipleTable"
						@selection-change="handleSelectionChangeFK"
						:data="cgPaymentData"
						style="width: 100%"
						:border="true"
				>
					<el-table-column
                            :selectable='checkboxT'
							type="selection"
							width="45"
					>
					</el-table-column>
					<el-table-column
							type="index"
							width="45"
							label="#"
							fixed>
					</el-table-column>
					<el-table-column
							prop="code"
							label="采购订单号"
							width="130"
							:show-overflow-tooltip="true"
							fixed>
					</el-table-column>
					<el-table-column
							prop="orderCode"
							label="销售订单号"
							:show-overflow-tooltip="true"
							width="130"
					>
					</el-table-column>
					<el-table-column
							prop="code"
							label="付款进度"
							:show-overflow-tooltip="true"
							width="100"
					>
						<template slot-scope="scope">
							{{scope.row.payNum}}/{{scope.row.totalPayNum}}
						</template>
					</el-table-column>
					<el-table-column
							prop="payAmount"
							label="本月应付"
							:show-overflow-tooltip="true"
							width="100"
					>
					</el-table-column>
                    <el-table-column
                            prop="shengyuPayAmount"
                            label="剩余应付"
                            :show-overflow-tooltip="true"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="shijiyifukuanbili"
                            label="实际已付款比例"
                            :show-overflow-tooltip="true"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="shijiPayAmount"
                            label="实际已付"
                            :show-overflow-tooltip="true"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="isPayment"
                            label="付款状态"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <dictname category="cg_fkstatus"  :v="scope.row.isPayment"/>
                        </template>
                    </el-table-column>
					<el-table-column
							prop="fukuanMoney"
							label="付款金额(元)"
							width="123">
						<template slot-scope="scope">
							<el-input v-model="scope.row.fukuanMoney"
									  @input="changeMoney(scope.row)"
									  placeholder="付款金额"
									  @keyup.native='keyupEvent($event)'
							></el-input>
						</template>
					</el-table-column>
                    <el-table-column
                            prop="fukuanbili"
                            label="付款比例(%)"
                            width="123">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.fukuanbili"
									  @input="changeInput(scope.row)"
									  placeholder="付款比例"
									  oninput="value=value.replace(/[^\d]/g, '')"
                                      maxlength="3"
                            ></el-input>
                        </template>
                    </el-table-column>
					<!--<el-table-column-->
							<!--prop="invoiceno"-->
							<!--label="发票号"-->
							<!--:show-overflow-tooltip="true"-->
							<!--width="100"-->
					<!--&gt;-->
					<!--</el-table-column>-->
					<el-table-column
							prop="payAmount"
							label="付款单号"
							:show-overflow-tooltip="true"
							width="100"
					>
					<template slot-scope="scope">
						{{scope.row.paymentOrderNo||'/'}}
					</template>
					</el-table-column>

                    <el-table-column
                            label="操作"
                            fixed="right"
                            width="100"
                    >
                        <template slot-scope="scope">
                            <div style="text-align: left;">
                                <el-button
                                        type="text"
                                        size="small"
                                        @click="fapiaoXiangqing(scope.row.code)"
                                        class="h-tableLink h-btn">
                                    发票详情
                                </el-button>

                            </div>
                        </template>
                    </el-table-column>

					<!--<el-table-column-->
							<!--prop="invoiceno"-->
							<!--label="发票附件"-->
							<!--:show-overflow-tooltip="true"-->
					<!--&gt;-->
						<!--<template slot-scope="scope">-->
							<!--<brupload v-if="scope.row.isNeedcred == 1"-->
									  <!--:refid="scope.row.invoiceno"-->
									  <!--:reftype=cgfkpz-->
									  <!--:showtime="false"-->
									  <!--delflag-->
									  <!--@filecallback=addfilecallbackpo>-->
							<!--</brupload>-->
						<!--</template>-->
					<!--</el-table-column>-->
				</el-table>
				<!--<div class="h-formLine h-mrt40">-->
					<!--<el-form :model="formInline" label-position="right" :inline="true"  class="demo-ruleForm h-formbLine">-->
						<!--<el-form-item label="附件" class="h-elformWrap-1">-->
							<!--<div v-for="(item,index) in fjlist" :key="index">-->
								<!--<brupload :refid="item"  :reftype=cgfkpz></brupload>-->
							<!--</div>-->
						<!--</el-form-item>-->
					<!--</el-form>-->
				<!--</div>-->
				<div class="xuanding" v-if="yxamount > 0" style="font-size: 0.2rem;">
					选定付款总额：
					<span class="allmoney"><span style="font-size: 0.22rem;">{{yxamount.toFixed(2)}}</span>元</span>
				</div>
				<!-- 新增批量修改 -->
				<div style="margin:10px auto">
					<el-input
						size="mini"
						style="width:100px;height: 28px; margin-right:10px"
						v-model="numberPiLiang"
						onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
						oninput="value=value.replace(/[^\d]/g, '')"
                        maxlength="3"
						:max="999">
					</el-input>
					<!-- <el-input  placeholder="请输入付款比例"  v-model="numberPiLiang"></el-input> -->
					<el-button size="mini" class="h-btn h-formBtn" @click="settingNumber">比例批量修改</el-button>
				</div>
			</div>
			<div class="h-txtCenter h-mrt60">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="cancelcg">取消</el-button>
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="sumitfk">确认提交</el-button>
			</div>
		</el-dialog>
		<!-- 条形码弹出层 -->
		<el-dialog :close-on-click-modal="false" :visible.sync="chehuidialogFormVisible" class="h-dialog2 wuliu">
            <!-- dialogImg -->
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>选择打印规格</h1>
					</div>
				</div>
			</div>
            <el-form  :model="addDelivery" label-width="100px" :inline="true" size="mini" class="addDeliveryForm">
                <el-form-item label="打印规格"  label-width="100" prop="size">
                    <el-select v-model="addDelivery.size" placeholder="请选择">
                        <el-option v-for="item in sizeCodeList" :key="item.value"
                            :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelP()">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="submitPrintCode">确 定</el-button>
            </div>
        </el-dialog>
		<el-dialog :close-on-click-modal="false" title="上传产品入库凭证" :visible.sync="uploadPricVisible" class="h-dialog2 wuliu">
            <div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>上传产品入库凭证</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding-top:20px;">
				<el-form>
					<el-form-item label="产品入库凭证" class="h-elformWrap-2" :rules="[
					{ required: true, message: '请上传产品入库凭证', trigger: 'change'},
					]">
						<brupload
								:refid="refid"
								reftype="采购订单-产品入库凭证"
								:limit="1"
								:showtime="false"
								uploadflag
								delflag
						>
						</brupload>
					</el-form-item>
				</el-form>
			</div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelHk">取 消</el-button>
            </div>
        </el-dialog>
		<el-dialog :close-on-click-modal="false" title="收货" :visible.sync="getGoodVisible" class="h-dialog2 wuliu">
            <div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>收货</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding-top:20px;">
				<el-form>
					<el-form-item label="产品入库凭证" class="h-elformWrap-2" prop="upload">
						<brupload
							:refid="refid"
							reftype="采购订单-产品入库凭证"
							:limit="1"
							:showtime="false"
						>
						</brupload>
					</el-form-item>
				</el-form>
			</div>
			<div class="h-formLine">
				<el-table
						ref="multipleTable"
						@selection-change="handleSelectionChange9390"
						:data="productlist2"
						stripe
						border
						style="width: 100%">
						<!-- <el-table-column
                                type="selection"
                                width="40"
                                label="全选">
                        </el-table-column> -->
						<el-table-column
								prop="code"
								label="采购单号"
								:show-overflow-tooltip="true"
								min-width="100">
						</el-table-column>
						<el-table-column
								prop="productNo"
								label="产品型号"
								min-width="100">
						</el-table-column>

						<el-table-column
								prop="count"
								label="总数量"
								min-width="75">
						</el-table-column>
						<el-table-column
								prop="receivedCount"
								label="已收数量"
								min-width="80">
						</el-table-column>
						<el-table-column
								prop="newReceivedCount"
								label="本次收货数量"
								min-width="95">
							<template slot-scope="scopes">
								<template  v-if="true">
									{{ scopes.row.count }}
									<!-- <el-input class="edit-input" size="small" v-model="scopes.row.count"></el-input> -->
								</template>
								<span v-else>{{ scopes.row.newReceivedCount }}</span>
							</template>
						</el-table-column>
				</el-table>
			</div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelGood">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="saveGood">确 定</el-button>
            </div>
        </el-dialog>

      <!--海外销售订单收货-->
      <el-dialog :close-on-click-modal="false" title="收货" :visible.sync="getGoodVisibleSales" class="h-dialog2 wuliu">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>收货</h1>
            </div>
          </div>
        </div>
        <div class="h-formLine" style="padding-top:20px;">
          <el-form>
            <el-form-item label="产品入库凭证" class="h-elformWrap-2" prop="upload">
              <brupload
                  :refid="refid"
                  reftype="采购订单-产品入库凭证"
                  :limit="1"
                  :showtime="false"
              >
              </brupload>
            </el-form-item>
          </el-form>
        </div>
        <div class="h-formLine">
          <el-table
              ref="multipleTable"
              @selection-change="handleSelectionChange9390"
              :data="productlist2"
              stripe
              border
              style="width: 100%">
            <!-- <el-table-column
                                type="selection"
                                width="40"
                                label="全选">
                        </el-table-column> -->
            <el-table-column
                prop="code"
                label="采购单号"
                :show-overflow-tooltip="true"
                min-width="100">
            </el-table-column>
            <el-table-column
                prop="productNo"
                label="产品型号"
                min-width="100">
            </el-table-column>

            <el-table-column
                prop="count"
                label="总数量"
                min-width="75">
            </el-table-column>
            <el-table-column
                prop="receivedCount"
                label="已收数量"
                min-width="80">
            </el-table-column>
            <el-table-column
                prop="newReceivedCount"
                label="本次收货数量"
                min-width="95">
              <template slot-scope="scopes">
                <template  v-if="true">
                  {{ scopes.row.count }}
                  <!-- <el-input class="edit-input" size="small" v-model="scopes.row.count"></el-input> -->
                </template>
                <span v-else>{{ scopes.row.newReceivedCount }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelGoodSalse">取 消</el-button>
          <el-button class="h-btn h-bBtn" @click="saveGoodSalse">确 定</el-button>
        </div>
      </el-dialog>

		<!--附件管理-批量上传入货通知-->
		<el-dialog
				:visible.sync="showFwkaipiao"
				v-if="showFwkaipiao"
				class="h-dialog2"
		>
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>OEM采购订单上传签收资料</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
				<h3 style="display: inline-block;">采购订单号:</h3>
				<h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhC}}</h4>
			</div>
			<div class="h-formLine" style="padding:20px;">
				<h3 style="display: inline-block;">签收资料</h3>
				<h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
				<brupload
						style="margin-top: 0.1rem;"
						@filecallback="ZFKPStatus"
						:refid="_.join(_.map(this.multipleSelection,'code'),',')"
						reftype="OEM_ZFQS"
						:uploadflag = "fjFlag"
						:delflag = "this.ks != 'Y'"/>
			</div>
			<div class="h-formLine" style="width:200px;padding:20px;">
				<h3 style="display: inline-block;">签收时间</h3>
				<el-date-picker
						v-model="date1"
						type="date"
						placeholder="选择日期"
						value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
				<el-button class="h-btn h-bBtn" @click="submitFujianC">提 交</el-button>
			</div>
		</el-dialog>

		<!--附件管理-查看/下载全部附件-->
		<el-dialog
				:visible.sync="showFujianD"
				v-if="showFujianD"
				class="h-dialog2"
		>
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>订单签收资料</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
				<h3 style="display: inline-block;">订单号:</h3>
				<h4 style="display: inline-block;margin-left: 0.1rem;">{{ddhC}}</h4>
			</div>
			<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
				<brupload
						style="margin-top: 0.1rem;"
						@filecallback="ZFKPStatus"
						:refid="refid"
						reftype="OEM_ZFQS"
						:uploadflag = "fjFlag && !(this.ks == 'Y')"
						:delflag = "this.ks != 'Y'"/>
			</div>
			<div class="h-formLine" style="width:200px;padding:20px;">
				<h3 style="display: inline-block;">签收时间</h3>
				<el-date-picker
						v-model="date1"
						type="date"
						placeholder="选择日期"
						value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
		</el-dialog>

		<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
		<createApply
				:visible.sync="showNewFukuan"
				v-if="showNewFukuan" @choseObj="choseObj"
				:cgCodeList="this.cgCodeListL"
				:supplierCode="this.supplierCode"
				:gscode = "this.gscode"
				title="付款"/>
        <div class="lj_imgclass" v-if="tpflags" @click="closeimgs">
            <div class="lj_imgclasstt">
                <img :src="'https://oms.haierbiomedical.com/api/file/fileopt/showImg?id='+imgid" alt="">
            </div>
        </div>

		<el-dialog :close-on-click-modal="false" :visible.sync="kaipiaoFlag" class="h-dialog2 wuliu">
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>下载开票资料</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
				<el-form  label-width="120px">
					<el-form-item label="上传9370开票资料：" v-auth="'shangchuanExcelTemplate'"  label-width="100">
						<brupload
								refid="shangchuanExcelTemplate"
								reftype="NX_KPZL9370"
								uploadflag
								delflag
						/>
					</el-form-item>
					<el-form-item label="上传9390开票资料：" v-auth="'shangchuanExcelTemplate'"  label-width="100">
						<brupload
								refid="shangchuanExcelTemplate"
								reftype="NX_KPZL9390"
								uploadflag
								delflag
						/>
					</el-form-item>
					<el-form-item label="上传1JC0开票资料：" v-auth="'shangchuanExcelTemplate'"  label-width="100">
						<brupload
								refid="shangchuanExcelTemplate"
								reftype="NX_KPZL1JC0"
								uploadflag
								delflag
						/>
					</el-form-item>
                    <el-form-item label="上传1RK0开票资料：" v-auth="'shangchuanExcelTemplate'"  label-width="100">
                        <brupload
                                refid="shangchuanExcelTemplate"
                                reftype="NX_KPZL1RK0"
                                uploadflag
                                delflag
                        />
                    </el-form-item>
                    <el-form-item label="上传1D90开票资料：" v-auth="'shangchuanExcelTemplate'"  label-width="100">
                        <brupload
                                refid="shangchuanExcelTemplate"
                                reftype="NX_KPZL1D90"
                                uploadflag
                                delflag
                        />
                    </el-form-item>
					<el-form-item label="生物医疗科技(9370)："  label-width="100">
						<li v-for="o,i in this.fileList9370" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
							<a class="el-upload-list__item-name" v-down="o.id"><i
									class="el-icon-document"></i>{{o.name}}
							</a>
						</li>
					</el-form-item>
					<el-form-item label="生物医疗股份(9390)："  label-width="100">
						<li v-for="o,i in this.fileList" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
							<a class="el-upload-list__item-name" v-down="o.id"><i
									class="el-icon-document"></i>{{o.name}}
							</a>
						</li>
					</el-form-item>
					<el-form-item label="青岛鸿鹄航空科技有限公司(1JC0)："  label-width="100">
						<li v-for="o,i in this.fileList1JC0" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
							<a class="el-upload-list__item-name" v-down="o.id"><i
									class="el-icon-document"></i>{{o.name}}
							</a>
						</li>
					</el-form-item>
                    <el-form-item label="青岛海尔生物医疗设备有限公司(1RK0)："  label-width="100">
                        <li v-for="o,i in this.fileList1RK0" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
                            <a class="el-upload-list__item-name" v-down="o.id"><i
                                    class="el-icon-document"></i>{{o.name}}
                            </a>
                        </li>
                    </el-form-item>
                    <el-form-item label="海乐苗（青岛）智能物联有限公司(1D90)："  label-width="100">
                        <li v-for="o,i in this.fileList1D90" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
                            <a class="el-upload-list__item-name" v-down="o.id"><i
                                    class="el-icon-document"></i>{{o.name}}
                            </a>
                        </li>
                    </el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false" :visible.sync="fkFlag" class="h-dialog2 wuliu">
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>付款操作手册</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
				<el-form  label-width="120px">
					<el-form-item label="操作手册上传" v-auth="'shangchuanExcelTemplate'"  label-width="100">
						<brupload
								refid="shangchuanExcelTemplate"
								reftype="CG_FK"
								uploadflag
								delflag
						/>
					</el-form-item>
					<el-form-item label="采购付款操作手册"  label-width="100">
						<li v-for="o,i in this.cgFkList" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
							<a class="el-upload-list__item-name" v-down="o.id"><i
									class="el-icon-document"></i>{{o.name}}
							</a>
						</li>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<!--附件管理-批量上传入货通知-->
		<el-dialog
				:visible.sync="fahuoDialogFormVisible"
				v-if="fahuoDialogFormVisible"
				class="h-dialog2"
		>
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>发货</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
				<h3 v-if="zhifakufaFlag" style="display: inline-block;color: red;">发货前请打印随货单和条形码!</h3>
				<h3 v-if="!zhifakufaFlag" style="display: inline-block;color: red;">发货前请打印条形码!</h3>
			</div>
			<div class="h-formLine" style="padding:20px;" v-if="qualityFlag">
				<h3 style="display: inline-block;">质量资料</h3>
				<brupload
						style="margin-top: 0.1rem;"
						:refid="cgCode"
						reftype="CG-ZLFJ"
						uploadflag
						:delflag = "this.cgStatus < 4"/>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="cancelQuality">取 消</el-button>
				<el-button class="h-btn h-bBtn" @click="submitFahuo">提 交</el-button>
			</div>
		</el-dialog>

		<!--附件管理-查看/下载全部附件-->
		<el-dialog
				:visible.sync="showQualityFile"
				v-if="showQualityFile"
				class="h-dialog2"
		>
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>质量资料</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
				<h3 style="display: inline-block;">订单号:</h3>
				<h4 style="display: inline-block;margin-left: 0.1rem;">{{cgCode}}</h4>
			</div>
			<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
				<brupload
						style="margin-top: 0.1rem;"
						:refid="cgCode"
						reftype="CG-ZLFJ"
						:uploadflag = "this.cgStatus < 4"
						:delflag = "this.cgStatus < 4"/>
			</div>
		</el-dialog>

	</div>
</template>
<script>
	import big from 'big.js'
    import ss from '../../api/SystemService'
    import util from "../../utils/util"
    import updownfile from '../../utils/updownfile'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
	import createApply from '../../components/invoice/createPayment'
	import supplierListService from "../../api/personal/supplierListService";
  import _ from "loadsh";
export default {
    components: {
        uploaddownexcel,createApply
    },
    data(){
        return{
          ssor: {
            idCollect: ""
          },
			numberPiLiang:'', //批量修改
			testData:[],// 备用数据
            imgid:'',
            tpflags: false,
			adminFlag:false,
			payFlag:false,
			zlFlag:false,//质量检测人员
      fpxqFlag:false,//发票详情
			uploadPricVisible:false,
			getGoodVisible:false,
      getGoodVisibleSales:false,
			refid:null,
            nwxflag:'all',
            neixiaoStatus:'',
			date1: '',
            caigdlxList: [{
                value: 'nx',
                label: '内销采购单'
            }, {
                value: 'wx',
                label: '外销采购单'
            }, {
                value: 'sh',
                label: '上海采购单'
            },],
			isAcceptList: [{
				value: '0',
				label: '未验收'
			}, {
				value: '1',
				label: '已验收'
			}, {
				value: ' ',
				label: '全部'
			},],
			isAccept:'',
            fukuanbili:'',
            shengyuPayAmount:'',
            shijiyifukuanbili:'',
			// 展开折叠筛选
			isScreen:false,
			closeScreen:require("@/assets/images/pimg/closeallic.png"),
			drawScreen:require("@/assets/images/pimg/dobleArr.png"),
			fklist: [],
            tableData4:[],
			yxamount:'',
            gysName:null,
			cgfkpz: '发票维护附件',
			cgPaymentData:[],
			orderCgPayment:false,
            //导入Excel
            uploaddownexcelflag: false,
            ddhB:'',
            ddhC:'',
            dialogFormVisible4:false,
			roleTypeVisible:false,
			saveHkVisible:false,
			proSupplier:{},
			showFujian: false,
			fjFlag: false,
			showFwkaipiao: false,
			ks:'N',
			fjCode: null,
			id: null,
			fhStatus: null,
			refid: null,
			reftype: null,
			showFujianD: false,
			bS: null,
			//游标集
			spanArr:[],
			childSpanArr:[],
			//游标定位
			position:'',
            checked:true,
            showOrhide:false,
			toshow:'purchaselist',
            status:1,
            names:'',
            input1:'',
            sele:'采购订单',
            formInline:{
                neixiaoStatus:'',
                cgId:"",
                suserName:"",
                status:"",
                statusList:[],
				ycountry:"",
                waybillId:"",
                productDes:'',
                productNo:'',
                productNoOrDes:'',
                orderCode:'',
				ycuname:"",
				isPayment:null,
				payType:null,
				ycId:"",
                sapCode:"",
                cgddlx:null,
				pzfileFlag:null,
				isAccept:'',
				purchaseOrgCode:'',
                pageSize:10,
                pageNo:1,
				cgIdList:null,
				shdatebegin:null,
				shdateend:null,
            },
			options2:[],
            multipleSelection: [],
			checkList:[],
            fh:{
				machineCode:"",
                waybillId:"",
                waybillName:"",
                waybillDate:"",
				cgId:"",
				cgIdStr:"",
				code:"",
				type:"",
				zhubiaoid:"",
				instid:"",
			},
			chehuidialogFormVisible: false,
			cgList: null,
			//title
			title:'',
			info:[],
			addDelivery:{
				size:''
			},
			sizeCodeList:[
                { value: '80*40',label: '80*40'},
                { value: '60*40',label: '60*40'},
                { value: '40*30',label: '40*30'},
            ],
			rules: {
				code:[
					 { required: true, message: '请输入发票号', trigger: 'blur' },
				],
				date:[
					 { required: true, message: '请输入发票日期', trigger: 'blur' },
				],
				fpje:[
					 { required: true, message: '请输入发票金额', trigger: 'blur' },
				],
				upload:[
					 { required: true, message: '请上传附件', trigger: 'blur' },
				],
				// fkdd:[
				// 	 { required: true, message: '请添加付款订单', trigger: 'blur' },
				// ],
				ddze:[
					 { required: true, message: '请输入订单总额', trigger: 'blur' },
				]
			},
			fh1:{
				code:"",
				date:"",
				fpje:'',
				upload:'',
				fkdd:'',
				ddze:'',
                fklist:'',
			},
            sh:{
                cgId:"",
				code:"",
                count:"",
                receivedCount:"",
                notreceivedCount:""
            },
			sh0:{
				code:"",
                orderCode:"",
				toSapFlag:"",
            },
            //列表
            tableData: [],
            q: {
                pageSize:10,
                pageNo:1,
                total:0
            },
			p:{
				invoiceno:null,
				invoicedate:null,
				idlist:[],
			},
            isCheck: false,
			dialogFormVisible:false,
			dialogFormVisibleSh0:false,
            dialogFormVisibleSh:false,
            dialogFormVisiblePay:false,
			chehuidialogFormVisible:false,
            showhistory:false,
            instid:null,
			//作废原因
			zfyydialogFormVisible:false,
			zuofeiyy:{
			    id:null,
			    yy:null,
			    bz:null,
			},
			//产品list
			productlist1:[],
			productlist2:[],
			//选中的
            selectedProductList: [],
			tableSelectedList:[],
			fjlist:[],
			kaipiaoFlag:false,
			fkFlag:false,
			fileList: [],
			fileList9370: [],
			fileList1JC0: [],
            fileList1RK0: [],
            fileList1D90: [],
			cgFkList: [],
            cgCodeListL:null,
			showNewFukuan:false,
			fahuoDialogFormVisible: false,
			zhifakufaFlag: false,
			qualityFlag: false,
			cgCode:null,
			cgStatus:null,
			fhFlag:false,
			cgId:null,
			cgType:null,
			cgZhubiaoid: null,
			showQualityFile:false,
			supplierCode:null,
			gscode:null,
        }
    },
    beforeRouteLeave(to,from,next){
        if(to.path=='/dingd/orderThrough'||to.path=='/personal/dealCenter'){
            from.meta.keepAlive = true;
		}else{
            from.meta.keepAlive = false;
		}
        to.query.keepAlive = false;
        next()
    },
    created(){
		this.adminFlag = this.$store.getters.hasRole('swyl_admin');
		this.payFlag = this.$store.getters.hasRole('shzxcaigoujingli');
		this.nwxflag = this.$route.meta.nwxflag;
		this.zlFlag = this.$store.getters.hasRole('swyl_cg_zljc');

    //这里单独判断是否有cglb_fpxq 因为v-auth与v-if同时使用有bug
    if(_.includes(this.$store.getters.rescodelist,"cglb_fpxq")){
       this.fpxqFlag = true;
    }else{
       this.fpxqFlag = false;
    }

		if(this.nwxflag == 'nx'){
		    this.neixiaoStatus='neixiao'
            this.formInline.cgddlx = 'nx'
/*			this.$alert("各位友商，介于OMS系统升级，增加供应商对账，录入发票功能，在5月26日（本周四）16点之后请勿登录系统操作数据（可查询订单），谢谢大家配合！", '系统提示', {
				confirmButtonText: '确定',
				type:'warning',
			});*/
		}else if(this.nwxflag == 'wx'){
            this.neixiaoStatus='waixiao'
/*            this.formInline.cgddlx = 'wx'
			this.$alert("各位友商，介于OMS系统升级，增加供应商对账，录入发票功能，在5月26日（本周四）16点之后请勿登录系统操作数据（可查询订单），谢谢大家配合！", '系统提示', {
				confirmButtonText: '确定',
				type:'warning',
			});*/
		}else if(this.nwxflag == 'all'){
/*			this.$alert("各位友商，介于OMS系统升级，增加供应商对账，录入发票功能，在5月26日（本周四）16点之后请勿登录系统操作数据（可查询订单），谢谢大家配合！", '系统提示', {
				confirmButtonText: '确定',
				type:'warning',
			});*/
			this.$alert("由于业务调整，开票公司根据采购订单列表---采购公司 开票，其他不变（产品型号、数量、金额须和系统一致）备注发票对应的采购单号", '开票提示', {
				confirmButtonText: '确定',
				type:'warning',
			});
		}
		/*else{
			this.neixiaoStatus='shanghai'
            this.formInline.cgddlx = 'sh'
        }*/
		this.showzhezhao()
		this.options2 = this.$store.getters.dicts["cg_status"];
		console.log("payFlag::",this.payFlag);
		this.rolelist = this._user.roles;
		this.rolelist.forEach(elements => {
			if (elements.id == "swyl_xiaoshoujl_wx"||elements.id == "swyl_admin" || elements.id == "caigoujingli") {
				this.roleTypeVisible = true;
			}
			if(elements.id == "swyl_haiwai_caiwu"){
				this.saveHkVisible = true;
			}
		});
		console.log("this.roleTypeVisible",this.roleTypeVisible);
		console.log("this.saveHkVisible",this.saveHkVisible);
	},
    handleFilter() {
        this.query();
    },
    methods:{
			getdatatime(){//默认显示今天
				this.date1= new Date();
			},
		//批量操作
		settingNumber(){
			console.log("shezhi")
			var numberPiLiang = this.numberPiLiang
			this.cgPaymentData[0].fukuanbili = numberPiLiang
			for (var i = 0; i < this.cgPaymentData.length; i++) {
				this.cgPaymentData[i].fukuanbili = numberPiLiang
				this.cgPaymentData[i].fukuanMoney = big(Number(this.testData[i].payAmount) * Number(numberPiLiang)/100).toFixed(2)
			}
			console.log(this.checkList)
			var amount = 0;
			for (var i = 0; i < this.checkList.length; i++) {
				amount = new big(amount).plus(Number(this.checkList[i].fukuanMoney));
			}
			this.yxamount = amount;
		},
		keyupEvent(e){
			e.target.value=e.target.value.replace(/[^\d.]/g, '');
			e.target.value=e.target.value.replace(/\.{2,}/g, '.');
			e.target.value=e.target.value.replace(/^\./g, '0.');
			e.target.value=e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0,e.target.value.length-1));
			e.target.value=e.target.value.replace(/^0[^\.]+/g, '0')
			e.target.value=e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
			this.input=e.target.value
		},
		changeMoney(v) {
			v.fukuanbili = new big(Number(v.fukuanMoney)).div(Number(v.payAmount))
			v.fukuanbili = v.fukuanbili.times(100);
			v.fukuanbili = v.fukuanbili.toFixed(2);
			this.handleSelectionChangeFK(this.checkList);
		},
		//查看签收资料附件
		seeFile(o) {
			this.fjFlag = o.status < 5 ? false : true;
			this.fjCode = o.code;
			this.id = o.id;
			this.fhStatus = o.status;
			this.bS = o.billingStatus;
			this.refid = this.ddhC = o.code;
			this.ks = o.thawStatus;
			this.date1 = o.acceptTime;
			this.showFujianD = true;
		},
		seeQualityFile(o){
			this.cgCode = o.code;
			this.cgStatus = o.status;
			this.showQualityFile = true;
		},
		//打印条形码
        toPrintCode(row){
            var row = row
            console.log(row)
            this.info = row
            this.chehuidialogFormVisible = true;
		},
		//确定打印条形码
		submitPrintCode(){
            var size = this.addDelivery.size
            if(size == ''){
                this.$message.error('请选择规格尺寸');
            }else{
				// this.info.size = size
				var code = this.info.code
				console.log(size,code)
				this.info ={
					size:size,
					code:code
				}
				ss.orderCgService.createCgBarCode(this.info).then(res =>{
					// console.log(res)
					// console.log(res.f)
					// console.log(res.msg)

						let link = document.createElement('a')
						let blob = new Blob([res],{type: 'application/pdf'});
						link.style.display = 'none'
						link.href = URL.createObjectURL(blob);
						//link.setAttribute('download')
						link.setAttribute('download', `产品码.pdf`)
						document.body.appendChild(link)
						link.click()
						document.body.removeChild(link)
						this.chehuidialogFormVisible = false ;

				})
            }
        },
		//表格
		handleSelectionChangeFK(val) {
			this.checkList = val;
			console.log(this.checkList)
			var amount = 0;
			for (var i = 0; i < this.checkList.length; i++) {
				amount = new big(amount).plus(Number(this.checkList[i].fukuanMoney));
			}
			// this.checkList.forEach(function(item, key) {
			// 	// amount += item.payAmount
			// 	if(item.payAmount){
			// 		amount += item.payAmount * item.fukuanbili/100;
			// 	}else{
			// 		item.payAmount = 0;
			// 		amount += item.payAmount * item.fukuanbili;
			// 	}
			// 	// amount += new big(amount).plus(item.payAmount);
			// })
			this.yxamount = amount;
			console.log(this.yxamount);
		},
        ylclick(v){
            console.log(v)
            this.imgid = v;
            this.tpflags = true;
        },
        closeimgs(){
            this.tpflags = false;
        },
        changeInput(v){
			if (v.fukuanbili == null || v.fukuanbili == '') {
				v.fukuanbili = 0;
			}
			var bl = new big(v.fukuanbili).div(100);
			v.fukuanMoney = bl.times(Number(v.payAmount));
			v.fukuanMoney = v.fukuanMoney.toFixed(2);
			// v.fukuanbili = new big(Number(v.fukuanMoney)).div(Number(v.payAmount))
			// v.fukuanbili = v.fukuanbili.times(100);
			// v.fukuanbili = v.fukuanbili.toFixed(2);
            this.handleSelectionChangeFK(this.checkList);
		},
        //打印采购单
        // this.multipleSelection

        shanghai_dayincaigd(){
        	if(this.multipleSelection.length==0)  {
                this.$msg.msge( "至少选择一条采购单打印！");
                return;
			}
			var ids = _.map(this.multipleSelection,"code").join(",");
			window.open(process.env.VUE_APP_AJAXURL+"/api/swyl/v1/dingd/bsc/OrderCg/showcg?codes="+ids)
		},
      printDispatchList() {
        if (this.multipleSelection.length == 0) {
          this.$msg.msge("至少选择一条发货单打印！");
          return;
        }
        var sign = 0;
        var suserCodes = this.multipleSelection[0].suserCode;
        for (let item of this.multipleSelection) {
          if (suserCodes != item.suserCode) {
            this.$msg.msge("所选项不是同一个供应商，请重新选择！");
            return;
          }
          if (item.status != "5" && item.status != "4") {
            this.$msg.msge("所选项非收货状态！");
            return;
          }
          if (item.waybillId==null || item.waybillName==null || item.waybillId=="" || item.waybillName==""){
            this.$msg.msge("请维护好所选项的物流信息！");
            return;
          }
          if (sign == 0) {
            this.ssor.idCollect = item.cgIdStr;
          } else {
            this.ssor.idCollect += "," + item.cgIdStr;
          }
          sign++;
        }
        var id = this.ssor;
        //console.log(this.ssor.idCollect)
        ss.chanpin.printDispatchList(id)
            .then(res => {
              let link = document.createElement('a')
              let blob = new Blob([res], {type: 'application/pdf'});
              link.style.display = 'none'
              link.href = URL.createObjectURL(blob);
              //link.setAttribute('download')
              link.setAttribute('download', `发货单.pdf`)
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)

            }).catch(function (error) {
          console.log(error)
        });
      },
        checkboxT(row){
            if(row.isPayment == 1 || row.isPayment == 2 ){
                return false;
            }else{
                return true;
            }
        },
		// 展开折叠
		collapseChange(){
			this.isScreen = !this.isScreen;
		},
		fileBack1(v) {
		    console.log(v)
		    this.fh1.upload = v.length;
		},
        fapiaoXiangqing(code) {
            this.dialogFormVisible4 =true;
            ss.orderCgService.selectInvoiceNoXinxiByCodeCg(code).then(rd => {
                this.tableData4 = rd;
                console.log(rd,"111111111111")
            });
        },
		// 删除数组最后一个元素
		truncate(arr) {
		   return arr.filter(function(v, i, ar) {
		      return i !== ar.length - 1
		   })
		},
		// 数组去重
        distinct(arr) {
            return Array.from(new Set(arr))
        },
		// 添加付款订单
		addfk(item) {
            if (item == '') {
                this.$msg.msge( "请输入订单号！");
            } else {
				console.log(this.fh1.fkdd, "!@######")
				console.log(this.fklist, "fjwgsiwg")
				console.log("item===" + item)
				var ischongfu = true;
				var arr = item.split(';');
				var id = item.indexOf(';');
				if (id == -1) {
					for (var i = 0; i < this.fklist.length; i++) {
						if (this.fklist[i] == item) {
							this.$msg.msge(this.fklist[i] + "该订单号已经存在，请重新选择！");
							this.fh1.fkdd = ''
							ischongfu = false;
						}
					}
				} else {
					for (var i = 0; i < this.fklist.length; i++) {
						for (var a = 0; a < arr.length; a++) {
							if (this.fklist[i] == arr[a]) {
								this.$msg.msge(arr[a] + "该订单号已经存在，请重新选择！");
								this.fh1.fkdd = ''

								ischongfu = false;
							}
						}
					}
				}

				if (ischongfu) {
					ss.orderCgService.deleteIsCode(this.fh1.fkdd).then(rd => {
						console.log(rd, "111111111182")
						this.money = rd.money;
						this.codelist = rd.codelist;
						this.cgIdList = rd.cgIdlist;
						console.log("this.cgIdList==" + this.cgIdList)
						var id = item.indexOf(';');
						if (id == -1) {
							this.fklist.push(item);
						} else {
							var arr;
							arr = item.split(';');
							this.fklist = this.fklist.concat(arr);
						}
						this.fklist = this.fklist.filter(function (s) {
							return s && s.trim();
						});
						this.fklist = this.distinct(this.fklist);
						this.fh1.ddze = this.fh1.ddze + this.money;
						this.fh1.fkdd = ''
						console.log("money==" + this.money)
						console.log("codelist==" + this.codelist)
					});
				}
			}
		},
		// 删除付款订单
		delfk(item,index){
            this.$msg.confirm("确认删除？",()=>{
                this.fklist.splice(index,1);
                console.log(item,"111111111222")
                ss.orderCgService.deleteIsCode(item).then(rd => {
                    console.log(rd,"111111111182")
                    this.money =rd.money;
                    this.fh1.ddze =(this.fh1.ddze*1000-this.money*1000)/1000;
                    console.log("money=="+this.money)
                    console.log("codelist=="+this.codelist)
                });
            })
			// this.fklist.splice(index,1);

		},
		getCheckAmount() {
			var amount = 0;
			this.checkList.forEach(function(item, key) {
				// amount += item.payAmount
				amount = new big(amount).plus(item.payAmount);
			})
			this.yxamount = amount;
		},
		addfilecallbackpo(v) {
			var list = this.list;
			_.forEach(this.list, function(item, key) {
				_.forEach(v, function(item1) {
					if (item1.refid == item.id && item1.reftype == "发票维护附件") {
						list[key].pzfileFlag = 1;
						return false;
					}
				})
			})
			this.list = list;
		},
    	//供应商付款（弹窗式）
		cgPayment(){
			var noflag = true;
			var cgIdList = [];
			//校验是否都有发票号
			if(this.multipleSelection.length>0){
				var suserCode = this.multipleSelection[0].suserCode;
				fg:
						for (var i = 0; i < this.multipleSelection.length; i++) {
							if(this.multipleSelection[i].status==5){
								if(suserCode==this.multipleSelection[i].suserCode){
									cgIdList.push(this.multipleSelection[i].cgId);
								}else{
									this.$msg.msge("所选项不是同一个供应商，请重新选择！");
									noflag =false;
									return false;
									break fg;
								}
							}/*else{
								this.$msg.msge("所选项中有订单未确认收货，请重新选择！");
								noflag = false;
								return false;
								break fg;
							}*/
							//只有status为3,4,5的采购订单才可以发起付款
							if(this.multipleSelection[i].status != 3 && this.multipleSelection[i].status != 4 && this.multipleSelection[i].status != 5){
								this.$msg.msge("只有审核通过,待收货,已收货的订单才可发起付款，请重新选择！");
								return false;
							}
						}
				// this.multipleSelection.forEach(element => {
				// 	if(element.status==5){
				// 		if(suserCode==element.suserCode){
				// 			cgIdList.push(element.cgId);
				// 		}else{
				// 			this.$msg.msge("所选项不是同一个供应商，请重新选择！");
				// 			noflag =false;
				// 			return false;
				// 		}
				// 	}else{
				// 		this.$msg.msge("所选项中有订单未确认收货，请重新选择！");
				// 		noflag = false;
				// 		return false;
				// 	}
				// });
			}else{
				this.$msg.msge("请选择付款采购订单！");
				noflag=false;
				return;
			}
			if(noflag){
				ss.orderCgService.getCgPaymentList(cgIdList).then(rd => {
				    console.log(rd,"========看看后台返回的是啥========")
					for(var i=0;i<rd.length;i++){
					    //rd[i]['fukuanbili'] = '';
					    if(rd[i].fukuanbili==''||rd[i].fukuanbili==null){
					        rd[i].fukuanbili=100
						}
					    if (rd[i].shijiPayAmount != null&&rd[i].shijiPayAmount!=0) {
							rd[i].fukuanMoney = rd[i].shijiPayAmount
						} else if (rd[i].shengyuPayAmount != null&&rd[i].shengyuPayAmount!=0) {
							rd[i].fukuanMoney = rd[i].shengyuPayAmount
						} else {
							rd[i].fukuanMoney = rd[i].payAmount
						}
					}
					this.cgPaymentData = rd;
					this.testData= rd;
				    sessionStorage.setItem('cgPaymentData',JSON.stringify(rd));
                    console.log("11111===111111",rd)

                  // this.formInline.invoiceno =rd[0].invoiceno;
                    // console.log("11111111111",rd[0].invoiceno)
                    // console.log(this.formInline.invoiceno,"111111112222223333444")
                    // var list =[]
                   //this.fjlist = this.formInline.invoiceno.split(",")
                    // console.log(list,'////////////////')
                    // for(var a=0;a<list.length;a++){
                    //     this.formInline.invoiceno=list[a];
                    // }
                    // console.log(this.formInline.invoiceno)
                    this.gysName = rd[0].suserName.split(',')[0];
				});
				this.orderCgPayment = true;
			}
		},
		cancelcg() {
			this.orderCgPayment = false;
            sessionStorage.removeItem('cgPaymentData');
		},
		//供应商确认付款
		sumitfk() {
			if (!this.checkList || this.checkList < 1) {
				this.$msg.msge("请选择付款采购订单！");
				return;
			}
			var flag = false;
			this.checkList.forEach(function(item, key) {
       		console.log(item,"111111111112222222333333")
				if (item.isPayment == 1) {
					flag = true;
					return false;
				}
			})
			if (flag) {
				this.$msg.msge("付款中采购订单不能重复付款！");
				return;
			}
			console.log(this.checkList,"11111111111wwww")
			ss.orderCgService.saveCgFk(this.checkList).then(rd => {
				if (rd.f) {
					this.$msg.msgs(rd.msg);
				} else {
					this.$msg.msge(rd.msg);
				}
				this.orderCgPayment = false;
			})
			sessionStorage.removeItem('cgPaymentData');
		},
		cellstyle(value){
			//console.log(value)
			if(value.row.status == 0 || value.row.status == 1 || value.row.status == 2 || value.row.status == 3){
				return {'font-weight': 'bold'};
			}
		},
        //导入Excel
        uploaddownexcelflagbtn() {
            this.uploaddownexcelflag = true;
        },
        uploadExcelFilecallback(rd) {
            this.query();
            this.$msg.msgs(rd.msg);
        },
		uploadPri(row){
			console.log("uploadPri:",row)
			//this.$msg.confirm("确认上传产品入库凭证?", () => {
			//	this.uploadPricVisible = true;
			//	this.refid = row.orderId;
			//});
			this.uploadPricVisible = true;
			this.refid = row.zhubiaoid;
		},
		shouhuoHk(data){
			console.log("uploadPri:",data)
			this.fh.cgId= data.cgId;
			this.fh.code= data.code;
			this.fh.type= data.type;
			this.fh.instid = data.instid;
			this.fh.zhubiaoid = data.zhubiaoid;
			this.fh.waybillId = data.waybillId;
			this.fh.waybillName = data.waybillName;
			this.fh.waybillDate = data.waybillDate;
			this.fh.machineCode = data.machineCode;
			this.fh.orderId = data.orderId;
			//ss.orderCgService.selectListByInstid(y).then(rd => {
			ss.orderCgService.selectListByInstid(this.fh).then(rd => {
				var newList = []
				rd.obj.forEach(item=>{
					let data={
						caigouquyu:item.caigouquyu,
						cdate: item.cdate,
						cgGroupCode: item.cgGroupCode ,
						cgId: item.cgId ,
						city: item.city ,
						code: item.code ,
						count: item.count ,
						cucode: item.cucode ,
						cuname: item.cuname ,
						currency: item.currency ,
						currencyCode: item.currencyCode ,
						currencyName: item.currencyName ,
						delflag: item.delflag ,
						detailAddress: item.detailAddress ,
						expectDate: item.expectDate ,
						factory: item.factory ,
						fahuoflag: item.fahuoflag ,
						fhdate: item.fhdate ,
						fhusername: item.fhusername ,
						instid: item.instid ,
						isPay: item.isPay ,
						ldate: item.ldate ,
						lucode: item.lucode ,
						machineCode:item.machineCode ,
						notreceivedCount:item.notreceivedCount ,
						orderCode: item.orderCode ,
						orderId: item.orderId ,
						orderType: item.orderType ,
						organization: item.organization ,
						payAmount: item.payAmount ,
						payNum:item.payNum ,
						payType: item.payType ,
						pendPayNum: item.pendPayNum ,
						posnr: item.posnr ,
						productCate: item.productCate ,
						productCateName:item.productCateName ,
						productDes:item.productDes ,
						productNo:item.productNo ,
						province:item.province ,
						purchaseOrgCode:item.purchaseOrgCode,
						receiveUnit: item.receiveUnit ,
						receivedCount: item.receivedCount ,
						newReceivedCount: "" ,
						receiver: item.receiver ,
						receverPhone:item.receverPhone ,
						sapCode:item.sapCode ,
						sapMessage:item.sapMessage ,
						sapOrderType:item.sapOrderType,
						sapPushDate: item.sapPushDate ,
						sapType:item.sapType ,
                        invoiceStatus:item.invoiceStatus ,
						shenhetime:item.shenhetime ,
						shenpiflag:item.shenpiflag ,
						shifoujisuan: item.shifoujisuan ,
						shuilv: item.shuilv ,
						source: item.source ,
						status:item.status ,
						suserCode: item.suserCode ,
						suserName: item.suserName ,
						totalPayNum: item.totalPayNum ,
						totalPrice: item.totalPrice ,
						type: item.type ,
						unitPrice: item.unitPrice ,
						waybillDate: item.waybillDate ,
						waybillId: item.waybillId,
						waybillName: item.waybillName ,
						waybillType:item.waybillType ,
						ycountry: item. ycountry,
						yremark: item. yremark,
						zhifakufa:item.zhifakufa ,
						zhubiaoid: item.zhubiaoid ,
					}
					newList.push(data)
				})
				//初始化默认数据
				this.productlist2 = newList

			})
			this.getGoodVisible = true;
			this.refid = data.zhubiaoid;

		},
    shouhuoSalse(data){
      console.log("uploadPri:",data)
      this.fh.cgId= data.cgId;
      this.fh.code= data.code;
      this.fh.type= data.type;
      this.fh.instid = data.instid;
      this.fh.zhubiaoid = data.zhubiaoid;
      this.fh.waybillId = data.waybillId;
      this.fh.waybillName = data.waybillName;
      this.fh.waybillDate = data.waybillDate;
      this.fh.machineCode = data.machineCode;
      this.fh.orderId = data.orderId;
      //ss.orderCgService.selectListByInstid(y).then(rd => {
      ss.orderCgService.selectListByInstid(this.fh).then(rd => {
        var newList = []
        rd.obj.forEach(item=>{
          let data={
            caigouquyu:item.caigouquyu,
            cdate: item.cdate,
            cgGroupCode: item.cgGroupCode ,
            cgId: item.cgId ,
            city: item.city ,
            code: item.code ,
            count: item.count ,
            cucode: item.cucode ,
            cuname: item.cuname ,
            currency: item.currency ,
            currencyCode: item.currencyCode ,
            currencyName: item.currencyName ,
            delflag: item.delflag ,
            detailAddress: item.detailAddress ,
            expectDate: item.expectDate ,
            factory: item.factory ,
            fahuoflag: item.fahuoflag ,
            fhdate: item.fhdate ,
            fhusername: item.fhusername ,
            instid: item.instid ,
            isPay: item.isPay ,
            ldate: item.ldate ,
            lucode: item.lucode ,
            machineCode:item.machineCode ,
            notreceivedCount:item.notreceivedCount ,
            orderCode: item.orderCode ,
            orderId: item.orderId ,
            orderType: item.orderType ,
            organization: item.organization ,
            payAmount: item.payAmount ,
            payNum:item.payNum ,
            payType: item.payType ,
            pendPayNum: item.pendPayNum ,
            posnr: item.posnr ,
            productCate: item.productCate ,
            productCateName:item.productCateName ,
            productDes:item.productDes ,
            productNo:item.productNo ,
            province:item.province ,
            purchaseOrgCode:item.purchaseOrgCode,
            receiveUnit: item.receiveUnit ,
            receivedCount: item.receivedCount ,
            newReceivedCount: "" ,
            receiver: item.receiver ,
            receverPhone:item.receverPhone ,
            sapCode:item.sapCode ,
            sapMessage:item.sapMessage ,
            sapOrderType:item.sapOrderType,
            sapPushDate: item.sapPushDate ,
            sapType:item.sapType ,
            invoiceStatus:item.invoiceStatus ,
            shenhetime:item.shenhetime ,
            shenpiflag:item.shenpiflag ,
            shifoujisuan: item.shifoujisuan ,
            shuilv: item.shuilv ,
            source: item.source ,
            status:item.status ,
            suserCode: item.suserCode ,
            suserName: item.suserName ,
            totalPayNum: item.totalPayNum ,
            totalPrice: item.totalPrice ,
            type: item.type ,
            unitPrice: item.unitPrice ,
            waybillDate: item.waybillDate ,
            waybillId: item.waybillId,
            waybillName: item.waybillName ,
            waybillType:item.waybillType ,
            ycountry: item. ycountry,
            yremark: item. yremark,
            zhifakufa:item.zhifakufa ,
            zhubiaoid: item.zhubiaoid ,
          }
          newList.push(data)
        })
        //初始化默认数据
        this.productlist2 = newList

      })
      this.getGoodVisibleSales = true;
      this.refid = data.zhubiaoid;

    },

		//作废订单
		deleteCgOrder(row) {
		    if (row.status == '0') {
		        this.$msg.confirm("确认撤销?", () => {
		            ss.orderCgService.deleteCgOrder(row.cgId, row.deleteReason).then(rd => {
		                this.$msg.msgs(rd.msg);
		                this.query();
		            });
		        });
		    } else {
		        this.zuofeiyy.id = row.cgId
		        this.zfyydialogFormVisible = true;
		    }
		},

		//批量上传签收资料
		uploadShFile() {
			if(this.ddhC == ''){
				this.$msg.msge("请勾选以上订单!!!");
				return false;
			}
			var flag1 = false
			var flag2 = false
			var flag3 = false
			this.multipleSelection.forEach((item, index) => {
				if(item.status < 3||item.status >5){
					flag1 = true;
					return;
				}
				if(!(item.type==1&&item.source==0&&item.deliveryMethod==1)){
					flag2 = true;
					return;
				}
/*				if(!(item.orderCategory=='2'&&item.orderCategory1=='24')){
					flag3 = true;
					return;
				}*/
			})
			if(flag1){
				this.$msg.msge("审核通过后的正常订单才能上传入货单,请重新选择!");
				return;
			}
			if(flag2){
				this.$msg.msge("只能选择OEM直发采购订单,请重新选择!");
				return;
			}
/*			if(flag3){
				this.$msg.msge("只能选择OEM直发采购订单,请重新选择!");
				return;
			}*/
			this.fjFlag = true;
			this.multipleSelection.forEach((item, index) => {
				if(item.status < 4){
					this.fjFlag = false;
				}
				if(item.thawStatus == 'Y'){
					this.ks = 'Y';
				}
			})
			this.showFwkaipiao = true;
			this.date1 = new Date();
		},

		submitFujianC(){
			var sapCodes = [];
			for(var i = 0;i < this.multipleSelection.length;i++){
				this.multipleSelection[i].acceptTime = this.date1;
				var obj = this.multipleSelection[i];
				sapCodes.push(obj);
				console.log('ids', obj);
			}
			ss.orderCgService.updateFjStatus(sapCodes).then(rd => {
				if(rd.f == true){
					this.$msg.msgs("上传开票资料成功");
					this.query();
					this.showFwkaipiao = false
				}
			});
		},

		ZFKPStatus() {
			// var saps = _.join(_.map(this.multipleSelection,"code"),",");
			var sapCodes = [];
			console.log("111111111111111222222222222223333333333333333333444444444444",sapCodes);
			for(var i = 0;i < this.multipleSelection.length;i++){
				this.multipleSelection[i].acceptTime = this.date1;
				var obj = this.multipleSelection[i];
				sapCodes.push(obj);
				console.log('ids', obj);
			}
			ss.orderCgService.updateFjStatus(sapCodes).then(rd => {
			});
		},

		chehui(row) {
            console.log(row);
            var msg = "确认撤回?";
            if(row.instid){
				msg = "该采购单是销售单自动生成，撤回后，请在待办里重新编辑，确认撤回?"
			}else{
                msg = "撤回该采购单会同步撤回sap的采购信息！";
			}
			if(row.type===3){
				this.fh.cgId = row.cgId;
				this.fh.type = row.type;
				this.fh.zhubiaoid = row.zhubiaoid;
				this.fh.code = row.code;
				this.fh.instid = row.instid;
				this.$msg.confirm(msg, () => {
					ss.orderCgService.chehuiCgOrderSh(this.fh).then(rd => {
						this.$msg.msgs(rd.msg);
						this.query();
						this.fh.cgId = "";
						this.fh.type = "";
						this.fh.zhubiaoid = "";
						this.fh.code = "";
						this.fh.instid = "";
					});
				});
			}else{
				 this.$msg.confirm(msg, () => {
					ss.orderCgService.chehuiCgOrder(row.cgId).then(rd => {
						this.$msg.msgs(rd.msg);
						this.query();
					});
				});
			}

		},
	    payMoney(row) {
            console.log(row);
            var msg = "确认已经付款?";
            // if(row.instid){
			// 	msg = "该采购单是销售单自动生成，撤回后，请在待办里重新编辑，确认撤回?"
			// }else{
            //     msg = "撤回该采购单会同步撤回sap的采购信息！";
			// }
			if(row.type===3){
				this.$msg.confirm(msg, () => {
					this.fh.cgId = row.cgId;
					this.fh.type = row.type;
					this.fh.zhubiaoid = row.zhubiaoid;
					this.fh.code = row.code;
					this.fh.instid = row.instid;
					ss.orderCgService.isPaySh(this.fh).then(rd => {
						this.$msg.msgs(rd.msg);
						this.query();
						this.fh.cgId = "";
						this.fh.type = "";
						this.fh.zhubiaoid = "";
						this.fh.code = "";
						this.fh.instid = "";
					});
				});
			}else{
				this.$msg.confirm(msg, () => {
					ss.orderCgService.isPay(row.cgId).then(rd => {
						this.$msg.msgs(rd.msg);
						this.query();
					});
				});
			}
		},

		submitzuofei(){
		    if (!this.zuofeiyy.yy) {
		        this.$msg.msge("请选择撤销原因");
		        return false;
		    }
		    var yybz = this.zuofeiyy.yy+":"+this.$store.getters.dictname("DD_ZFYY",this.zuofeiyy.yy)+":"+this.zuofeiyy.bz;
		    this.$msg.confirm("确认撤销?", () => {
		        ss.orderCgService.deleteCgOrder(this.zuofeiyy.id, yybz).then(rd => {
		            this.$msg.msgs(rd.msg);
		            this.query();
		            this.zfyydialogFormVisible = false
		        });
		    });
		},
		showzhezhao() {
		    ss.salesList.toshow(this.toshow).then(rd => {
		        console.log(rd)
		        if (rd == false) {
		            this.showOrhide = false;
		        } else {
		            this.showOrhide = true;
		        }
		    })
		},

		//记录游标的方法
		getSpanArr() {

			//游标集，每个元素的下标对应当前页table的每一行的行号，每个元素的数字对应这一行条件相同的共重复了几行
			this.spanArr = [];
			let arryList = [];
			this.tableData.forEach((item0, index0) => {
				let cgIdStr = "";
				let statusStr = "";
				let fahuoStrFlag =false;
				//遍历当前表元素
				this.tableData.forEach((item, index) => {
					if(item0.zhubiaoid === item.zhubiaoid){
						cgIdStr += item.cgId+",";
						statusStr += item.status+",";
						if(item.fahuoflag){
							fahuoStrFlag=true;
						}
					}

				})
				item0.cgIdStr=cgIdStr.substring(0,cgIdStr.length-1);
				item0.cstatusStr=statusStr.substring(0,statusStr.length-1);
				item0.cfahuoStrFlag=fahuoStrFlag;
				console.log(cgIdStr.substring(0,cgIdStr.length-1))
				console.log(item0)
			})
			//遍历当前表元素
			this.tableData.forEach((item, index) => {

				//当第一行时
				if (index === 0) {

					//默认先放第一行是1次
					this.spanArr.push(1);

					//记录当前重复行的位置
					this.position = 0;

					//其他行
				} else {

					//如果该行上的zhubiaoid与上一行上的zhubiaoid重复
					if (this.tableData[index].zhubiaoid === this.tableData[index - 1].zhubiaoid&&this.tableData[index].code === this.tableData[index - 1].code) {

						//从游标集中取到记录重复行的那行的重复数字，自增1(又重复一次)
						this.spanArr[this.position] += 1;

						//因为这次重复了，所以放入0记录作为这行实际上应该被合并掉
						this.spanArr.push(0);

						//若不重复
					} else {

						//继续向游标集放入一个1作为本行没有重复的独立一次记录
						this.spanArr.push(1);

						//记录重复行位置的游标移动到本行位置
						this.position = index;

					}
				}
			})
		},

		//合并单元行方法
		objectSpanMethod({row, column, rowIndex, columnIndex}) {
			//console.log("row::",row,"column::",column,"rowIndex::",rowIndex,"columnIndex::",columnIndex);
			if (
				(column.property == 'code')
				||
				(column.property == 'orderCode')
				||
				(column.property == 'status')
				||
				(
					(column.label == '订单状态')
				)||
				(
					(column.label == '操作') &&
					(row.type == '3' )
				)||
				(
					(column.label == '操作') &&
					(row.type == '2' )&&(row.orderCategory=='2')&&(row.orderCategory1=='28')
				)
			) {

				const _row = this.spanArr[rowIndex];

				//该行跨了几列
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				}
			}

		},

        closeIt(){
			this.showOrhide = false;
			if (this.checked) {
			    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
			        console.log(rd)
			        this.showOrhide = false;
			    })
			} else {
			    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
			        console.log(rd)
			        this.showOrhide = false;
			    })
			}
		},
		nextStep(i){
			console.log(i)
			if(this.status ==1){
					this.status = 2;
			}else if(this.status ==2){
					this.status = 3;
			}else if(this.status ==3){
					this.status = 4;
			}else if(this.status ==4){
					this.status = 5;
			}else if(this.status ==5){
					this.status = 6;
					document.documentElement.scrollTop = 300;
			}else if(this.status ==6){
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
			}
		},
        //表格
        handleSelectionChange(val) {
            this.multipleSelection = val;
            var str = '';
            var str2 = '';
            this.multipleSelection.forEach(element => {
                str += element.cgId + ',';
                str2 += element.code + ',';
            });
            str = str.substring(0,str.length-1);
            str2 = str2.substring(0,str2.length-1);
            this.ddhB = str;
            this.ddhC = str2;
        },
        //检索按钮功能
        checkData(){
            this.q.pageNo = 1;
            this.query();
        },
		jiansuo(){
            console.log(this.formInline.isPayment,"wertyuigggggggg")

			// var list =this.cgPaymentData;
            var list = JSON.parse(sessionStorage.getItem('cgPaymentData'));
            for(var i=0;i<list.length;i++){
               list[i].isPayment = this.formInline.isPayment;
			}
            ss.orderCgService.jiansuoFukuan(list).then(rd => {
               console.log(rd,"11111111111111111111111111")
                for(var i=0;i<rd.length;i++){
                    if(rd[i].fukuanbili==''||rd[i].fukuanbili==null){
                        rd[i].fukuanbili=100
                    }
                }
                this.cgPaymentData = rd;
                console.log("11111===111111",rd)
                this.gysName = rd[0].suserName.split(',')[0];
			});
		},
        //重置按钮功能
        resetData(){
            this.formInline.cgId = ""
            this.formInline.neixiaoStatus = ""
			this.formInline.orderCode = ""
            this.formInline.suserName = ""
            this.formInline.status = ""
            this.formInline.statusList = []
			this.formInline.cdatebegin = ""
			this.formInline.cdateend = ""
            this.formInline.shenhetimebegin = ""
            this.formInline.shenhetimeend = ""
			this.formInline.waybillId = ""
			this.formInline.ycountry = ""
			this.formInline.ycuname = ""
			this.formInline.ycId = ""
            this.formInline.productDes = ""
            this.formInline.productNo = ""
			this.formInline.productNoOrDes = ""
			this.formInline.cgddlx = ""
            this.formInline.sapCode = ""
			this.formInline.isAccept = null
            this.formInline.isPayment=null
			this.formInline.payType=null
			this.formInline.pzfileFlag=null
			this.formInline.purchaseOrgCode = ''
            this.q.pageSize = 10;

            this.query();

        },
        chongzhil(){
			this.formInline.isPayment=null
			this.formInline.payType=null
        },
        newCgOrder() {
            this.$router.push({path: '/dingd/orderCreate'});
		},
        payment() {
            this.$router.push("/dingd/orderCgPayment");
		},
        query(p) {
            this.q.ids=null;
            this.q.cgId = this.formInline.cgId
            this.q.neixiaoStatus = this.neixiaoStatus
			this.q.orderCode = this.formInline.orderCode
            this.q.suserName = this.formInline.suserName
            this.q.status = this.formInline.status
            this.q.statusList = this.formInline.statusList
			this.q.cdatebegin = this.formInline.cdatebegin
			this.q.cdateend = this.formInline.cdateend
            this.q.shenhetimebegin = this.formInline.shenhetimebegin
            this.q.shenhetimeend = this.formInline.shenhetimeend
			this.q.waybillId = this.formInline.waybillId
			this.q.ycountry = this.formInline.ycountry
			this.q.ycuname = this.formInline.ycuname
			this.q.ycId = this.formInline.ycId
			this.q.isPayment = this.formInline.isPayment
			this.q.payType = this.formInline.payType
			this.q.pzfileFlag = this.formInline.pzfileFlag
			this.q.productDes   =this.formInline.productDes
            this.q.productNo   =this.formInline.productNo
            this.q.productNoOrDes   =this.formInline.productNoOrDes
			this.q.isAccept =this.formInline.isAccept
            this.q.sapCode   =this.formInline.sapCode
            this.q.cgddlx   =this.formInline.cgddlx
			this.q.isAccept =this.formInline.isAccept
			this.q.purchaseOrgCode = this.formInline.purchaseOrgCode
			this.q.shdatebegin = this.formInline.shdatebegin
			this.q.shdateend = this.formInline.shdateend
            ss.orderCgService.selectPage(this.q).then(rd => {
                 this.q.total = rd.total;
                 this.tableData = rd.records;
                 console.log(rd,"!!!!!!!!!!!!!!!!!")
				this.getSpanArr();
            });
        },
        queryfahuo(p) {
            console.log("重新刷新页面")
            this.q.status = 3
            ss.orderCgService.selectPage(this.q).then(rd => {
                this.q.total = rd.total;
                this.tableData = rd.records;
                console.log(rd,"!!!!!!!!!!!!!!!!!")
                this.getSpanArr();
            });
        },
        //编辑
        editPage(v){
			if(v.ycId){
				this.$router.push({path: '/dingd/orderCreateYC',query:{cgId:v.cgId}});
			}else{
				this.$router.push({path: '/dingd/orderCreate',query:{cgId:v.cgId}});
			}
        },
		//查询供应商商品占比
		selectProSupplier(x){
			this.proSupplier = {};
			ss.orderCgService.selectProSupplier(x).then(rd => {
				this.proSupplier = rd;
				console.log('我在这儿呀1', this.proSupplier.id);

				if(this.proSupplier.id){
					this.showFujian = true;
				}
			})
		},
        getDetail(data,id,instid,zhubiaoid,type,cgIdStr) {
			console.log(data)
			if(type===3){
            	this.$router.push({path: '/dingd/orderThroughSh',query:{cgIdStr:cgIdStr,cgId:id,instid:instid,zhubiaoid:zhubiaoid}});
			}else{
				if(null!=data.orderCategory&&data.orderCategory=='2'&&null!=data.orderCategory1&&data.orderCategory1=='28'){
					this.$router.push({path: '/dingd/orderThroughHk',query:{cgIdStr:cgIdStr,cgId:id,instid:instid,zhubiaoid:zhubiaoid}});
				}else{
					this.$router.push({path: '/dingd/orderThrough',query:{cgId:id}});
				}

			}
			// const {href} = this.$router.resolve({path: '/dingd/orderThrough',query:{cgId:id}})
            // window.open(href);
		},

        getDetailEditNx(orderId, instid) {
            this.$router.push({path: '/dingd/orderCgApprove',query:{ywid: orderId, instid: instid}});
        },
        getDetailEditWx(orderId, instid) {
            this.$router.push({path: '/dingd/orderCgWxddApprove',query:{ywid: orderId, instid: instid}});
        },
        getDetailEditSh(orderId, instid) {
            this.$router.push({path: '/dingd/orderCgShddApprove',query:{ywid: orderId, instid: instid}});
        },

        approve(row) {
            this.$router.push({
                path: row.dburl,
                query: {ywid: row.cgId,taskid:row.taskId, instid: row.instid, taskstatus: '0', link: 3}
            });
		},
        //明细导出
        exportExcel() {

            var idlist=[];
            this.multipleSelection.forEach(element => {
                idlist.push(element.cgId);
            });
            if (idlist) {
                this.q.ids = idlist.join(",");
            } else {
                this.q.ids ='';

            }
            this.q.cgId = this.formInline.cgId
            this.q.suserName = this.formInline.suserName
            this.q.status = this.formInline.status

            updownfile.down("/api/swyl/v1/dingd/bsc/OrderCg/downloadExcel",this.q,"post",'params');

        },

        allWaybillCommit() {
            if(this.ddhB == ''){
                this.$msg.msge("请勾选维护物流信息的订单!!!");
                return false;
            }
            var flag1 = true;
            this.multipleSelection.forEach((item, index) => {
                if(!((item.status == 3 || item.status == 4)&&(item.waybillType == "2"||item.waybillType == "3"))){
                    flag1 = false;
                    return;
                }
            })
            if(!flag1){
                this.$msg.msge("存在不满足维护物流信息条件的订单，请检查勾选项!");
                return;
            }
            this.fh.code= this.ddhC;
            this.fh.cgId= this.ddhB;
            this.fh.waybillId = '';
            this.fh.waybillName = '';
            this.fh.waybillDate = '';
            this.fh.machineCode = '';
            this.dialogFormVisible = true;
        },
		//批量发货
        fahuoBatch(){
            if(this.ddhB == ''){
                this.$msg.msge("请勾选要发货的订单!!!");
                return false;
            }
            var flag1 = true;
            var fhFlag = false;
            var list = [];
            this.multipleSelection.forEach((item, index) => {
                if(!(item.status == 3&&(item.waybillType == "2"||item.waybillType == "3"))){
                    flag1 = false;
                    return;
                }
                // if(item.waybillName == null || item.waybillName == '' || item.waybillId == null || item.waybillId == ''){
                //     fhFlag = true;
                //     return;
                // }
              list.push(item);

            })
            // if(fhFlag){
            //     this.$msg.msge("发货前必须维护物流信息!");
            //     return;
            // }
            if(!flag1){
                this.$msg.msge("存在不满足发货条件的订单，请检查勾选项!");
                return;
            }
			//校验，质量抽检的供应商不允许批量发货
			//更新发货信息
			ss.orderCgService.checkQuality(list).then(rd => {
				if(rd.f){
					//更新发货信息
					ss.orderCgService.fahuoBatch(list).then(rd => {
						this.$msg.msgs(rd.msg)
						this.query();
					});
				}
			});

		},

		fahuo(v) {

			//直发，发货前必须维护物流信息
			// if(v.status == 3 && (v.waybillType == "2"||v.waybillType == "3")&& v.orderCategory1 != "28" ){
			// 	var fhFlag = false;
			// 	if(v.waybillName == null || v.waybillName == '' || v.waybillId == null || v.waybillId == ''){
			// 		fhFlag = true;
			// 	}
			//
			// 	if(fhFlag){
			// 		this.$msg.msge("发货前必须维护物流信息!");
			// 		return;
			// 	}
			// }


			if(v.deliveryMethod == '2'){
				this.zhifakufaFlag = true;
			}else {
				this.zhifakufaFlag = false;
			}
			var data = {
				usercode:null,
			}
			data.usercode = v.suserCode;
			this.cgCode = v.code;
			this.cgStatus = v.status;
			this.cgId = v.cgId;
			this.cgType =v.type;
			this.cgZhubiaoid = v.zhubiaoid;

			//获取供应商信息，判断是否需要上传质量抽检资料
			supplierListService.queryOne(data).then(rd => {
				console.log(rd,'查询单个供应商信息')
				if(rd.obj.isQuality == 1){
					this.qualityFlag = true;
				}else{
					this.qualityFlag = false;
				}
				this.fahuoDialogFormVisible = true;
			})
			//alert(deliveryMethod)
			/*if(deliveryMethod == '2'){
				//备货
				this.$msg.confirm("确认要发货吗？提示请打印随货单和条形码",()=>{
				this.fh.cgId = v;
				this.fh.type = s;
				this.fh.zhubiaoid = q;
				this.fh.code = t;
				console.log(this.fh)
				//更新发货信息
				ss.orderCgService.fahuo(this.fh).then(rd => {
						console.log("dsdsgodho")
						this.$msg.msgs(rd.msg)
						this.query();
					});
				})
			}else{
				this.$msg.confirm("确认要发货吗？请打印条形码",()=>{
				this.fh.cgId = v;
				this.fh.type = s;
				this.fh.zhubiaoid = q;
				this.fh.code = t;
				console.log(this.fh)
				//更新发货信息
				ss.orderCgService.fahuo(this.fh).then(rd => {
						console.log("dsdsgodho")
						this.$msg.msgs(rd.msg)
						this.query();
					});
				})
			}*/
		},
		submitFahuo(){
			this.fh.cgId = this.cgId;
			this.fh.type = this.cgType;
			this.fh.zhubiaoid = this.cgZhubiaoid;
			this.fh.code = this.cgCode;
			console.log(this.fh)
			//更新发货信息
			ss.orderCgService.fahuo(this.fh).then(rd => {
				console.log("dsdsgodho")
				this.$msg.msgs(rd.msg)
				this.query();
				this.fahuoDialogFormVisible = false;
			});
		},
		cancelQuality(){
			this.cgCode = null;
			this.cgStatus = null;
			this.cgId = null;
			this.cgType =null;
			this.cgZhubiaoid = null;

			this.fahuoDialogFormVisible = false;
		},
		updateWaybillId(data){
		    console.log(data);
			this.dialogFormVisible = true ;
			this.fh.cgId= data.cgId;
			this.fh.cgIdStr= data.cgIdStr;
			this.fh.code= data.code;
			this.fh.type= data.type;
			this.fh.instid = data.instid;
			this.fh.zhubiaoid = data.zhubiaoid;
			this.fh.waybillId = data.waybillId;
            this.fh.waybillName = data.waybillName;
            this.fh.waybillDate = data.waybillDate;
			this.fh.machineCode = data.machineCode;
		},
		// invoice(){
		// 	var noflag = true;
		// 	//校验是否都有发票号
		// 	if(this.multipleSelection.length>0){
		// 		var invoiceno = this.multipleSelection[0].invoiceno;
		// 		var invoicedate = this.multipleSelection[0].invoicedate;
		// 		var cgfpno = invoiceno;
		// 		var cgfkdate = invoicedate;
		// 		this.multipleSelection.forEach(elements=>{
		// 			var invoice = elements.invoiceno;
		// 			var invoiceda = elements.invoicedate;
		// 			if(elements.status ==5){
		// 				if(invoiceno && invoice){
		// 					cgfpno = invoice;
		// 					cgfkdate = invoiceda;
		// 					if(invoiceno !=invoice){
		// 						this.$msg.msge("所选项的发票号不同，不允许同时维护，请重新选择！");
		// 						noflag =false;
		// 					}
		// 					if(noflag){
		// 						return false;
		// 					}
		// 				}
		// 			}else if(elements.status !=5){
		// 				if(noflag){
		// 					this.$msg.msge("所选项中有订单尚未确认收货，请重新选择！");
		// 					noflag =false;
		// 				}
		// 				if(noflag){
		// 					return false;
		// 				}
		// 			}
		// 		})
		// 	}else{
		// 		this.$msg.msge("请选择要维护发票的采购订单！");
		// 		noflag=false;
		// 		return false;
		// 	}
		// if(noflag){
		// 		this.dialogFormVisiblePay = true ;
		// 		for(var i=0;i<this.multipleSelection.length;i++){
		// 			this.fklist.push(this.multipleSelection[i].code)
		// 		}
         //    this.fh1.ddze =0;
         //    for(var i=0;i<this.multipleSelection.length;i++){
         //        this.fh1.ddze =this.multipleSelection[i].totalPrice+this.fh1.ddze;
         //    }
		// 		this.fh1.code= cgfpno;
		// 		this.fh1.date= cgfkdate;
		// 	}
		// },
        invoice(){
            console.log(this.multipleSelection, "///////////////////////")
            sessionStorage.setItem("list",JSON.stringify(this.multipleSelection));
            this.$router.push({
                name: '/dingd/invoicemaintenance',
                params: {
                    list: this.multipleSelection
                }
            });
        },
		cancel() {
            this.dialogFormVisible = false ;
			this.showFwkaipiao = false;
		},
		cancelP() {
            this.chehuidialogFormVisible = false ;
		},
		cancelHk(){
			this.uploadPricVisible = false ;
		},
		cancelGood(){
			this.getGoodVisible = false ;
		},
    cancelGoodSalse(){
      this.getGoodVisibleSales = false ;
    },



		cancel1() {
			    this.fh1.code="",
                this.fh1.date="",
                this.fh1.fpje='',
                this.fh1.upload='',
                this.fh1.fkdd='',
                this.fh1.ddze='',
				this.fklist =[],
				console.log(this.fh1,"!!!!!!!")
			this.dialogFormVisiblePay = false ;
            console.log("this.fh1.ddze=="+this.fh1.ddze)
        		},
        saveTo() {
			console.log(this.fh)
			console.log(this.fh.cgId.split(','))
			console.log(this.fh.cgId.split(',').length)
			if(this.fh.type===3&&this.fh.cgId.split(',').length===1){
				//this.fh.code="";
				//更新发货信息
				this.fh.cgId=this.fh.cgIdStr
				ss.orderCgService.updateWaybillIdSh(this.fh).then(rd => {
					this.$msg.msgs(rd.msg)
				});
				this.dialogFormVisible = false;
				this.query();
			}else{
				this.fh.code="";
				//更新发货信息
				ss.orderCgService.updateWaybillId(this.fh).then(rd => {
					this.$msg.msgs(rd.msg)
				});
				this.dialogFormVisible = false;
				this.query();
			}
		},
		saveTo1(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.p.invoiceno=this.fh1.code;
					console.log("this.p.invoiceno==="+this.p.invoiceno)
					this.p.invoicedate=this.fh1.date;
					this.p.fpje =this.fh1.fpje;
					this.p.ddze=this.fh1.ddze;
                    console.log("this.p.ddze=="+this.p.ddze);
                    console.log("this.p.fpje=="+this.p.fpje);
                    console.log("this.p.invoicedate=="+this.p.invoicedate);
                    this.p.fklist =this.fklist;
                    console.log("this.p.fklist=="+this.p.fklist);
                    //this.p.upload =this.fh1.upload;
                    console.log("this.p.upload=="+this.p.upload);
					var idlist=[];
					this.multipleSelection.forEach(element => {
											idlist.push(element.cgId);
										});
					this.p.idlist = idlist;
					/* if (idlist) {
						this.q.ids = idlist.join(",");
						console.log("qqqqqqqqqqqqqq",this.q.ids)
					} else {
						this.q.ids ='';
					}*/
					console.log("this.p.idlist=="+this.p.idlist )

					ss.orderCgService.saveInvoicePage(this.p).then(rd => {
						this.$msg.msgs(rd.msg);
						this.dialogFormVisiblePay = false;
						this.query();
					});
				} else {
					return false;
				}
			});



		},
        shouhuoSh(data,y,v,vv,vvv,vvvv,code,s,q,t) {
            console.log(data);
            if(data.type===3){
                this.sh0.code= data.code;
                this.sh0.orderCode= data.orderCode;
                //根据采购订单对应的销售订单校验销售订单传SAP创建成功时间，
                //如果创建时间是2021年3月1日之前创建的继续走原来的收货页面以及收货方法；
                //如果创建时间是2021年3月1日之后创建的走新建的收货页面以及收货方法
                ss.orderCgService.checkOrderCg(this.sh0).then(rd => {
                    console.log("rd:",rd);
                    if(rd.msg){
                        this.sh0.toSapFlag=0;
                        this.sh.type=3;
                        this.fh.cgId= data.cgId;
                        this.fh.code= data.code;
                        this.fh.type= data.type;
                        this.fh.instid = data.instid;
                        this.fh.zhubiaoid = data.zhubiaoid;
                        this.fh.waybillId = data.waybillId;
                        this.fh.waybillName = data.waybillName;
                        this.fh.waybillDate = data.waybillDate;
                        this.fh.machineCode = data.machineCode;
                        //ss.orderCgService.selectListByInstid(y).then(rd => {
                        ss.orderCgService.selectListByInstid(this.fh).then(rd => {
                            var newList = []
                            rd.obj.forEach(item=>{
                                let data={
                                    caigouquyu:item.caigouquyu,
                                    cdate: item.cdate,
                                    cgGroupCode: item.cgGroupCode ,
                                    cgId: item.cgId ,
                                    city: item.city ,
                                    code: item.code ,
                                    count: item.count ,
                                    cucode: item.cucode ,
                                    cuname: item.cuname ,
                                    currency: item.currency ,
                                    currencyCode: item.currencyCode ,
                                    currencyName: item.currencyName ,
                                    delflag: item.delflag ,
                                    detailAddress: item.detailAddress ,
                                    expectDate: item.expectDate ,
                                    factory: item.factory ,
                                    fahuoflag: item.fahuoflag ,
                                    fhdate: item.fhdate ,
                                    fhusername: item.fhusername ,
                                    instid: item.instid ,
                                    isPay: item.isPay ,
                                    ldate: item.ldate ,
                                    lucode: item.lucode ,
                                    machineCode:item.machineCode ,
                                    notreceivedCount:item.notreceivedCount ,
                                    orderCode: item.orderCode ,
                                    orderId: item.orderId ,
                                    orderType: item.orderType ,
                                    organization: item.organization ,
                                    payAmount: item.payAmount ,
                                    payNum:item.payNum ,
                                    payType: item.payType ,
                                    pendPayNum: item.pendPayNum ,
                                    posnr: item.posnr ,
                                    productCate: item.productCate ,
                                    productCateName:item.productCateName ,
                                    productDes:item.productDes ,
                                    productNo:item.productNo ,
                                    province:item.province ,
                                    purchaseOrgCode:item.purchaseOrgCode,
                                    receiveUnit: item.receiveUnit ,
                                    receivedCount: item.receivedCount ,
                                    newReceivedCount: "" ,
                                    receiver: item.receiver ,
                                    receverPhone:item.receverPhone ,
                                    sapCode:item.sapCode ,
                                    sapMessage:item.sapMessage ,
                                    sapOrderType:item.sapOrderType,
                                    sapPushDate: item.sapPushDate ,
                                    sapType:item.sapType ,
                                    invoiceStatus:item.invoiceStatus ,
                                    shenhetime:item.shenhetime ,
                                    shenpiflag:item.shenpiflag ,
                                    shifoujisuan: item.shifoujisuan ,
                                    shuilv: item.shuilv ,
                                    source: item.source ,
                                    status:item.status ,
                                    suserCode: item.suserCode ,
                                    suserName: item.suserName ,
                                    totalPayNum: item.totalPayNum ,
                                    totalPrice: item.totalPrice ,
                                    type: item.type ,
                                    unitPrice: item.unitPrice ,
                                    waybillDate: item.waybillDate ,
                                    waybillId: item.waybillId,
                                    waybillName: item.waybillName ,
                                    waybillType:item.waybillType ,
                                    ycountry: item. ycountry,
                                    yremark: item. yremark,
                                    zhifakufa:item.zhifakufa ,
                                    zhubiaoid: item.zhubiaoid ,
                                    acceptTime: this.date1,
                                }
                                newList.push(data)
                            })
                            //初始化默认数据
                            this.productlist1 = newList

                        })
                        // console.log("1111111",v);

                        this.dialogFormVisibleSh = true;
                    }else{
                        this.sh0.toSapFlag=1;
                        this.sh.cgId = v;
                        this.sh.count = vv;
                        this.sh.receivedCount = vvv;
                        this.sh.notreceivedCount = vvvv;
                        this.sh.code=code;
                        this.sh.type=s;
                        this.sh.zhubiaoid=q;
                        this.sh.code=t;
                        this.dialogFormVisibleSh0 = true;
                    }
                });
                /*
                */
            }else{
				this.sh.cgId = v;
				this.sh.count = vv;
				this.sh.receivedCount = vvv;
				this.sh.notreceivedCount = vvvv;
				this.sh.code=code;
				this.sh.type=s;
				this.sh.zhubiaoid=q;
				this.sh.code=t;
				this.dialogFormVisibleSh0 = true;
            }

        },
        cancelSh() {
			this.dialogFormVisibleSh0 = false ;
			this.dialogFormVisibleSh = false ;
			this.productlist1=[]
		},
		handleSelectionChange9390(v){
			this.selectedProductList = v;
			console.log(this.selectedProductList)
		},
        saveToSh() {
			console.log("this.sh.type",this.sh.type)
			console.log("this.sh0",this.sh0)
			if(this.sh.type !='3'){
				//更新发货信息
				ss.orderCgService.updateCount(this.sh).then(rd => {
					if (rd.f){
						this.query();
						this.$msg.msgs(rd.msg)
						this.dialogFormVisibleSh0 = false ;newProject
					}  else {
						this.$msg.msge(rd.msg)
						this.dialogFormVisibleSh0 = false ;
					}
				});

			}else {
				if(this.sh0.toSapFlag!='0'){
					//更新发货信息
					ss.orderCgService.updateCount(this.sh).then(rd => {
						if (rd.f){
							this.query();
							this.$msg.msgs(rd.msg)

						}  else {
							this.$msg.msge(rd.msg)
						}
					});

					this.dialogFormVisibleSh0 = false ;
				}else{
					//更新收货信息
					console.log(this.selectedProductList)
					if(this.selectedProductList.length>0){
						let submitFlag = true;
						this.selectedProductList.forEach(item=>{
							if(null==item.newReceivedCount||item.newReceivedCount==""||item.newReceivedCount==0){
								submitFlag = false;
							}
						})
						if(submitFlag){
							ss.orderCgService.updateCountList(this.selectedProductList).then(rd => {
								if (rd.f){
									this.query();
									this.$msg.msgs(rd.msg)

								}  else {
									this.$msg.msge(rd.msg)
								}
							});
							this.productlist1=[]
							this.selectedProductList=[]
							this.dialogFormVisibleSh = false ;
						}else{
							this.$msg.msge("您选择要收货的产品行对应的本次收货数量必须大于0，请重新填写!");
						}

					}else{
						this.$msg.msge("请滑动滚轮，在要选择收货的产品行前面的方框中打对号，然后在进行确认!");
						return;
					}
				}

			}
			/*
			var entitylist = [];

			for (var c in this.tableData3) {

				entitylist.push({

					numlist: this.zy.numlist,
					type: this.zy.type,
					waybillType: this.zy.waybillType,
					detailAddress: this.zy.detailAddress,
					expectDate: this.zy.expectDate,
					status: this.zy.status,
					cgGroupCode: this.zy.cgGroupCode,
					purchaseOrgCode: this.zy.purchaseOrgCode,
					province: this.zy.province,
					city: this.zy.city,
					country: this.zy.country,
					receiver: this.zy.receiver,
					receverPhone: this.zy.receverPhone,
					receiveUnit: this.zy.receiveUnit,


					instid: this.instId || null,
					orderId:this.tableData3[c].orderId || '',
					orderCode:this.tableData3[c].orderCode || '',
					cgId: this.tableData3[c].cgId || '',
					zhubiaoid: this.tableData3[c].zhubiaoid || '',
					productCateName: this.tableData3[c].productCateName,
					productDes: this.tableData3[c].productDes,
					productCate: this.tableData3[c].productCate,
					productNo: this.tableData3[c].productNo,
					suserCode: this.tableData3[c].suserCode,
					suserName: this.tableData3[c].suserName,
					unitPrice: this.tableData3[c].unitPrice,
					count: this.tableData3[c].count,
					proId: this.tableData3[c].proId,
					totalPrice: (new big(parseFloat(this.tableData3[c].unitPrice)).times(parseInt(this.tableData3[c].count))).toString(),

				})

			}*/

			/*
            ss.orderCgService.updateCountList(this.productlist1).then(rd => {
                if (rd.f){
                    this.query();
                    this.$msg.msgs(rd.msg)

                }  else {
                    this.$msg.msge(rd.msg)
                }
            });
			this.productlist1=[]
			this.selectedProductList=[]
			this.dialogFormVisibleSh = false ;
			*/
		},
		saveGood(){
			//console.log("this.sh.type",this.sh)
			console.log("productlist2",this.productlist2)
			//更新收货信息
			//console.log(this.selectedProductList)
			//console.log(this.selectedProductList)
			this.$msg.confirm("确认收货?", () => {
		        ss.orderCgService.updateCountByHk(this.productlist2).then(rd => {
					this.getGoodVisible = false ;
					this.productlist2=[]
					this.selectedProductList=[]
		            this.$msg.msgs(rd.msg);
		            this.query();

		        }).catch(error=>{
                   	this.getGoodVisible = false ;
					this.productlist2=[]
					this.selectedProductList=[]
					this.$msg.msgs(rd.msg);
                });
		    });
			/*if(this.selectedProductList.length>0){
				let submitFlag = true;
				this.selectedProductList.forEach(item=>{
					if(null==item.newReceivedCount||item.newReceivedCount==""||item.newReceivedCount==0){
						submitFlag = false;
					}
				})
				if(submitFlag){
					ss.orderCgService.updateCountByHk(this.selectedProductList).then(rd => {
						if (rd.f){
							this.query();
							this.$msg.msgs(rd.msg)

						}  else {
							this.$msg.msge(rd.msg)
						}
					});
					this.productlist1=[]
					this.selectedProductList=[]
					this.dialogFormVisibleSh = false ;
				}else{
					this.$msg.msge("您选择要收货的产品行对应的本次收货数量必须大于0，请重新填写!");
				}

			}else{
				this.$msg.msge("请滑动滚轮，在要选择收货的产品行前面的方框中打对号，然后在进行确认!");
				return;
			}*/

		},
      saveGoodSalse(){
        console.log("productlist2",this.productlist2)
        //更新收货信息
        //console.log(this.selectedProductList)
        //console.log(this.selectedProductList)
        this.$msg.confirm("确认收货?", () => {
          ss.orderCgService.updateCountBySales(this.productlist2).then(rd => {
            this.getGoodVisible = false ;
            this.productlist2=[]
            this.selectedProductList=[]
            this.$msg.msgs(rd.msg);
            this.query();

          }).catch(error=>{
            this.getGoodVisible = false ;
            this.productlist2=[]
            this.selectedProductList=[]
            this.$msg.msgs(rd.msg);
          });
        });
      },
        genzongLiuch(r){
            this.instid = r;
            this.showhistory = true;
        },

		uploadKpFile(){
			this.kaipiaoFlag = true;
		},

		uploadFkFile(){
			this.fkFlag = true;
		},

		newFukuan(cgList) {
			var cgIdList = [];
			//校验是否都有发票号
			if(this.multipleSelection.length>0){
				var suserCode = this.multipleSelection[0].suserCode;
				var organization = this.multipleSelection[0].purchaseOrgCode;
				fg:
					for (var i = 0; i < this.multipleSelection.length; i++) {
						if(this.multipleSelection[i].status==5){
							if(suserCode==this.multipleSelection[i].suserCode){
								cgIdList.push(this.multipleSelection[i].cgId);
							}else{
								this.$msg.msge("所选项不是同一个供应商，请重新选择！");
								noflag =false;
								return false;
								break fg;
							}
						}
						//只有status为3,4,5的采购订单才可以发起付款
						if(this.multipleSelection[i].status != 3 && this.multipleSelection[i].status != 4 && this.multipleSelection[i].status != 5){
							this.$msg.msge("只有审核通过,待收货,已收货的订单才可发起付款，请重新选择！");
							return false;
							break fg;
						}

						if(organization != this.multipleSelection[i].purchaseOrgCode){
							this.$msg.msge("所选采购单采购组织不同,请重新选择！");
							return false;
							break fg;
						}
					}
			}else{
				this.$msg.msge("请选择付款采购订单！");
				noflag=false;
				return;
			}
            var dataList = null
            for(var i=0;i<this.multipleSelection.length;i++){
            	if(i == 0){
					dataList = this.multipleSelection[i].cgId;
				}else {
					dataList = dataList + ',' + this.multipleSelection[i].cgId;
				}
            }
            this.cgCodeListL = dataList;
            this.supplierCode = this.multipleSelection[0].suserCode;
			this.gscode = this.multipleSelection[0].purchaseOrgCode;


			var data = {
				cgIds:[],
			}
			data.cgIds = dataList;
			//付款账期校验
			ss.orderCgService.checkCgPayment(data).then(rd => {
				if (rd.f){
					this.showNewFukuan = true;
				}
			});
		},
		choseObj() {
			this.showNewFukuan = false;
		},
		formatDate(row, column) {
			// 获取单元格数据
			let data = row[column.property]
			if(data == null || data == '') {
				return null
			}
			let dt = new Date(data)
			return this.$util.riQi3(dt);
		},

    },
    mounted() {
        this.query();

		updownfile.listdownfile({refid:"shangchuanExcelTemplate", reftype: "NX_KPZL9390"}).then(rd => {
			if(rd.obj && rd.obj.length>0){
				for(var i = 0;i<rd.obj.length;i++){
					this.fileList.push(rd.obj[i])
				}
			}
		})
		updownfile.listdownfile({refid:"shangchuanExcelTemplate", reftype: "NX_KPZL9370"}).then(rd => {
			if(rd.obj && rd.obj.length>0){
				for(var i = 0;i<rd.obj.length;i++){
					this.fileList9370.push(rd.obj[i])
				}
			}
		})

		updownfile.listdownfile({refid:"shangchuanExcelTemplate", reftype: "NX_KPZL1JC0"}).then(rd => {
			if(rd.obj && rd.obj.length>0){
				for(var i = 0;i<rd.obj.length;i++){
					this.fileList1JC0.push(rd.obj[i])
				}
			}
		})

        updownfile.listdownfile({refid:"shangchuanExcelTemplate", reftype: "NX_KPZL1RK0"}).then(rd => {
            if(rd.obj && rd.obj.length>0){
                for(var i = 0;i<rd.obj.length;i++){
                    this.fileList1RK0.push(rd.obj[i])
                }
            }
        })

        updownfile.listdownfile({refid:"shangchuanExcelTemplate", reftype: "NX_KPZL1D90"}).then(rd => {
            if(rd.obj && rd.obj.length>0){
                for(var i = 0;i<rd.obj.length;i++){
                    this.fileList1D90.push(rd.obj[i])
                }
            }
        })

		updownfile.listdownfile({refid:"shangchuanExcelTemplate", reftype: "CG_FK"}).then(rd => {
			if(rd.obj && rd.obj.length>0){
				for(var i = 0;i<rd.obj.length;i++){
					this.cgFkList.push(rd.obj[i])
				}
			}
		})
	}
}
</script>
<style>
	 .wuliu .h-dialogForm .h-elformWrap-2 .el-form-item__label{
		width: 25%;
	}
	 .wuliu .h-dialogForm .h-elformWrap-2 .el-form-item__content{
		width: 64%;
	}
	 .wuliu .h-formbLine .h-elformWrap-2{
		width: 100%!important;
	}
	.purchaselist	.h-tableLink{
		padding:0px!important;
	}
	.h-formbLine .fkinput .el-form-item__content .el-input__inner{
		border: 1px solid #dedede;
	}
	.addDeliveryForm{
        padding: 0.54rem 0.28rem 0 0.25rem;
    }

</style>
<style scoped lang="scss">
    .lj_imgclass{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999;
        width: 100%;
        height: 100%;
    }
    .lj_imgclasstt{
        text-align: center;
        padding: 3% 0;
        width: 100%;
        height: 100%;
        overflow-y: auto;
    }
	.el-select .el-tag--small{
		height: 24px !important;
	}
	.el-input--suffix{
		vertical-align: bottom !important;
	}
	.fklistBox{
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		margin-top: 0.14rem;
	}
	.fklists{
		padding: 0 0.05rem;
		margin-left: 0.1rem;
		background: #d9e9f3;
		height: 0.3rem;
		line-height: 0.3rem;
		color: #6d829c;
		margin-bottom: 0.14rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.14rem;
	}
	.fklists:hover{
		color: #489cf5;
	}
	.fklists:nth-child(4n+1){
		margin-left: 0;
	}
	.fkcircle{
		width: 0.15rem;
		height: 0.15rem;
		line-height: 0.13rem;
		color: #d0e0ea;
		background: #8dafc5;
		margin-left: 0.08rem;
		cursor: pointer;
		border-radius: 50%;
		font-size: 0.1rem;
		text-align: center;
	}
	.fkBtn{
		width: 0.8rem;
		height: 0.28rem;
		font-size: 0.14rem;
		color: #fff;
		text-align: center;
		line-height: 0.28rem;
		background: #238cfd;
		cursor: pointer;
	}
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;

		}
		.steps{
			position: absolute;
			z-index: 1;

		}
		.step1{
			top: 0.8rem;
			left: 0;
			width: 6rem;
			height: 11.5rem;
		}
		.step2{
			top: 1.63rem;
			right: 6.9rem;
			width: 9.4rem;
			height: 1.9rem;
		}
		.step3{
			width: 2.3rem;
			height: 1.9rem;
			right: 3.7rem;
			top: 1.6rem;
		}
        .step4{
			width: 3rem;
			height: 2.3rem;
			right: 0.7rem;
			top: 1.65rem;
		}
        .step5{
			width: 6.25rem;
			height: 1.3rem;
			right: 0.37rem;
			top: 4.25rem;
		}
        .step6{
			width: 3.9rem;
			height: 1.1rem;
			left: 2.6rem;
			top: 7.1rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
